export default [
  {
    popularity: 99,
    newness: 342,
    style: 245,
    trending: 245,
    alphaIndex: 0,
    family: 'ABeeZee',
    category: 'sans-serif',
    variants: [
      'regular',
      'italic',
    ],
    subsets: [
      'latin',
    ],
    version: 'v12',
    lastModified: '2019-04-29',
  },
  {
    popularity: 51,
    newness: 689,
    style: 340,
    trending: 340,
    alphaIndex: 1,
    family: 'Abel',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-05-01',
  },
  {
    popularity: 297,
    newness: 109,
    style: 130,
    trending: 130,
    alphaIndex: 2,
    family: 'Abhaya Libre',
    category: 'serif',
    variants: [
      'regular',
      '500',
      '600',
      '700',
      '800',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'sinhala',
    ],
    version: 'v4',
    lastModified: '2019-04-29',
  },
  {
    popularity: 60,
    newness: 664,
    style: 341,
    trending: 341,
    alphaIndex: 3,
    family: 'Abril Fatface',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-05-01',
  },
  {
    popularity: 361,
    newness: 771,
    style: 342,
    trending: 342,
    alphaIndex: 4,
    family: 'Aclonica',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 64,
    newness: 511,
    style: 343,
    trending: 343,
    alphaIndex: 5,
    family: 'Acme',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-05-01',
  },
  {
    popularity: 228,
    newness: 690,
    style: 344,
    trending: 344,
    alphaIndex: 6,
    family: 'Actor',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 213,
    newness: 657,
    style: 345,
    trending: 345,
    alphaIndex: 7,
    family: 'Adamina',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v12',
    lastModified: '2019-04-29',
  },
  {
    popularity: 233,
    newness: 437,
    style: 84,
    trending: 84,
    alphaIndex: 8,
    family: 'Advent Pro',
    category: 'sans-serif',
    variants: [
      '100',
      '200',
      '300',
      'regular',
      '500',
      '600',
      '700',
    ],
    subsets: [
      'greek',
      'latin-ext',
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 543,
    newness: 593,
    style: 346,
    trending: 346,
    alphaIndex: 9,
    family: 'Aguafina Script',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 571,
    newness: 349,
    style: 347,
    trending: 347,
    alphaIndex: 10,
    family: 'Akronim',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-18',
  },
  {
    popularity: 427,
    newness: 594,
    style: 348,
    trending: 348,
    alphaIndex: 11,
    family: 'Aladin',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 315,
    newness: 673,
    style: 349,
    trending: 349,
    alphaIndex: 12,
    family: 'Aldrich',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 324,
    newness: 268,
    style: 246,
    trending: 246,
    alphaIndex: 13,
    family: 'Alef',
    category: 'sans-serif',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin',
      'hebrew',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 102,
    newness: 512,
    style: 41,
    trending: 41,
    alphaIndex: 14,
    family: 'Alegreya',
    category: 'serif',
    variants: [
      'regular',
      'italic',
      '500',
      '500italic',
      '700',
      '700italic',
      '800',
      '800italic',
      '900',
      '900italic',
    ],
    subsets: [
      'greek',
      'greek-ext',
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v12',
    lastModified: '2019-04-29',
  },
  {
    popularity: 362,
    newness: 513,
    style: 42,
    trending: 42,
    alphaIndex: 15,
    family: 'Alegreya SC',
    category: 'serif',
    variants: [
      'regular',
      'italic',
      '500',
      '500italic',
      '700',
      '700italic',
      '800',
      '800italic',
      '900',
      '900italic',
    ],
    subsets: [
      'greek',
      'greek-ext',
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 110,
    newness: 259,
    style: 20,
    trending: 20,
    alphaIndex: 16,
    family: 'Alegreya Sans',
    category: 'sans-serif',
    variants: [
      '100',
      '100italic',
      '300',
      '300italic',
      'regular',
      'italic',
      '500',
      '500italic',
      '700',
      '700italic',
      '800',
      '800italic',
      '900',
      '900italic',
    ],
    subsets: [
      'greek',
      'greek-ext',
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 243,
    newness: 260,
    style: 21,
    trending: 21,
    alphaIndex: 17,
    family: 'Alegreya Sans SC',
    category: 'sans-serif',
    variants: [
      '100',
      '100italic',
      '300',
      '300italic',
      'regular',
      'italic',
      '500',
      '500italic',
      '700',
      '700italic',
      '800',
      '800italic',
      '900',
      '900italic',
    ],
    subsets: [
      'greek',
      'greek-ext',
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 632,
    newness: 0,
    style: 106,
    trending: 106,
    alphaIndex: 18,
    family: 'Aleo',
    category: 'serif',
    variants: [
      '300',
      '300italic',
      'regular',
      'italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v2',
    lastModified: '2019-04-18',
  },
  {
    popularity: 265,
    newness: 514,
    style: 350,
    trending: 350,
    alphaIndex: 19,
    family: 'Alex Brush',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 125,
    newness: 515,
    style: 351,
    trending: 351,
    alphaIndex: 20,
    family: 'Alfa Slab One',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 204,
    newness: 682,
    style: 352,
    trending: 352,
    alphaIndex: 21,
    family: 'Alice',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'cyrillic',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 456,
    newness: 671,
    style: 353,
    trending: 353,
    alphaIndex: 22,
    family: 'Alike',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v11',
    lastModified: '2019-04-29',
  },
  {
    popularity: 633,
    newness: 654,
    style: 354,
    trending: 354,
    alphaIndex: 23,
    family: 'Alike Angular',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-18',
  },
  {
    popularity: 421,
    newness: 862,
    style: 247,
    trending: 247,
    alphaIndex: 24,
    family: 'Allan',
    category: 'display',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v11',
    lastModified: '2019-04-29',
  },
  {
    popularity: 262,
    newness: 876,
    style: 355,
    trending: 355,
    alphaIndex: 25,
    family: 'Allerta',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 206,
    newness: 877,
    style: 356,
    trending: 356,
    alphaIndex: 26,
    family: 'Allerta Stencil',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 234,
    newness: 460,
    style: 357,
    trending: 357,
    alphaIndex: 27,
    family: 'Allura',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 626,
    newness: 516,
    style: 158,
    trending: 158,
    alphaIndex: 28,
    family: 'Almendra',
    category: 'serif',
    variants: [
      'regular',
      'italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v11',
    lastModified: '2019-04-18',
  },
  {
    popularity: 836,
    newness: 298,
    style: 358,
    trending: 358,
    alphaIndex: 29,
    family: 'Almendra Display',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-18',
  },
  {
    popularity: 793,
    newness: 517,
    style: 359,
    trending: 359,
    alphaIndex: 30,
    family: 'Almendra SC',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-18',
  },
  {
    popularity: 657,
    newness: 387,
    style: 360,
    trending: 360,
    alphaIndex: 31,
    family: 'Amarante',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 215,
    newness: 758,
    style: 159,
    trending: 159,
    alphaIndex: 32,
    family: 'Amaranth',
    category: 'sans-serif',
    variants: [
      'regular',
      'italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 79,
    newness: 639,
    style: 248,
    trending: 248,
    alphaIndex: 33,
    family: 'Amatic SC',
    category: 'handwriting',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'hebrew',
    ],
    version: 'v12',
    lastModified: '2019-05-01',
  },
  {
    popularity: 464,
    newness: 479,
    style: 361,
    trending: 361,
    alphaIndex: 34,
    family: 'Amethysta',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 503,
    newness: 174,
    style: 218,
    trending: 218,
    alphaIndex: 35,
    family: 'Amiko',
    category: 'sans-serif',
    variants: [
      'regular',
      '600',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'devanagari',
    ],
    version: 'v3',
    lastModified: '2019-04-29',
  },
  {
    popularity: 107,
    newness: 381,
    style: 160,
    trending: 160,
    alphaIndex: 36,
    family: 'Amiri',
    category: 'serif',
    variants: [
      'regular',
      'italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'arabic',
    ],
    version: 'v12',
    lastModified: '2019-04-29',
  },
  {
    popularity: 574,
    newness: 206,
    style: 249,
    trending: 249,
    alphaIndex: 37,
    family: 'Amita',
    category: 'handwriting',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'devanagari',
    ],
    version: 'v4',
    lastModified: '2019-04-18',
  },
  {
    popularity: 521,
    newness: 310,
    style: 362,
    trending: 362,
    alphaIndex: 38,
    family: 'Anaheim',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 455,
    newness: 649,
    style: 363,
    trending: 363,
    alphaIndex: 39,
    family: 'Andada',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 476,
    newness: 683,
    style: 364,
    trending: 364,
    alphaIndex: 40,
    family: 'Andika',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 772,
    newness: 806,
    style: 365,
    trending: 365,
    alphaIndex: 41,
    family: 'Angkor',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'khmer',
    ],
    version: 'v11',
    lastModified: '2019-04-18',
  },
  {
    popularity: 370,
    newness: 782,
    style: 366,
    trending: 366,
    alphaIndex: 42,
    family: 'Annie Use Your Telescope',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 366,
    newness: 863,
    style: 161,
    trending: 161,
    alphaIndex: 43,
    family: 'Anonymous Pro',
    category: 'monospace',
    variants: [
      'regular',
      'italic',
      '700',
      '700italic',
    ],
    subsets: [
      'greek',
      'latin-ext',
      'cyrillic',
      'latin',
    ],
    version: 'v12',
    lastModified: '2019-04-29',
  },
  {
    popularity: 296,
    newness: 665,
    style: 367,
    trending: 367,
    alphaIndex: 44,
    family: 'Antic',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 642,
    newness: 414,
    style: 368,
    trending: 368,
    alphaIndex: 45,
    family: 'Antic Didone',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 227,
    newness: 415,
    style: 369,
    trending: 369,
    alphaIndex: 46,
    family: 'Antic Slab',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 24,
    newness: 825,
    style: 370,
    trending: 370,
    alphaIndex: 47,
    family: 'Anton',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-05-01',
  },
  {
    popularity: 123,
    newness: 625,
    style: 250,
    trending: 250,
    alphaIndex: 48,
    family: 'Arapey',
    category: 'serif',
    variants: [
      'regular',
      'italic',
    ],
    subsets: [
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 820,
    newness: 575,
    style: 371,
    trending: 371,
    alphaIndex: 49,
    family: 'Arbutus',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-18',
  },
  {
    popularity: 238,
    newness: 353,
    style: 372,
    trending: 372,
    alphaIndex: 50,
    family: 'Arbutus Slab',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 196,
    newness: 801,
    style: 373,
    trending: 373,
    alphaIndex: 51,
    family: 'Architects Daughter',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 236,
    newness: 103,
    style: 69,
    trending: 69,
    alphaIndex: 52,
    family: 'Archivo',
    category: 'sans-serif',
    variants: [
      'regular',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v4',
    lastModified: '2019-04-29',
  },
  {
    popularity: 124,
    newness: 354,
    style: 374,
    trending: 374,
    alphaIndex: 53,
    family: 'Archivo Black',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 67,
    newness: 355,
    style: 70,
    trending: 70,
    alphaIndex: 54,
    family: 'Archivo Narrow',
    category: 'sans-serif',
    variants: [
      'regular',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-05-01',
  },
  {
    popularity: 598,
    newness: 110,
    style: 251,
    trending: 251,
    alphaIndex: 55,
    family: 'Aref Ruqaa',
    category: 'serif',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin',
      'arabic',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 417,
    newness: 117,
    style: 71,
    trending: 71,
    alphaIndex: 56,
    family: 'Arima Madurai',
    category: 'display',
    variants: [
      '100',
      '200',
      '300',
      'regular',
      '500',
      '700',
      '800',
      '900',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
      'tamil',
    ],
    version: 'v4',
    lastModified: '2019-04-29',
  },
  {
    popularity: 30,
    newness: 882,
    style: 162,
    trending: 162,
    alphaIndex: 57,
    family: 'Arimo',
    category: 'sans-serif',
    variants: [
      'regular',
      'italic',
      '700',
      '700italic',
    ],
    subsets: [
      'greek',
      'greek-ext',
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
      'hebrew',
    ],
    version: 'v12',
    lastModified: '2019-05-01',
  },
  {
    popularity: 358,
    newness: 518,
    style: 375,
    trending: 375,
    alphaIndex: 58,
    family: 'Arizonia',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 175,
    newness: 519,
    style: 376,
    trending: 376,
    alphaIndex: 59,
    family: 'Armata',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 369,
    newness: 101,
    style: 163,
    trending: 163,
    alphaIndex: 60,
    family: 'Arsenal',
    category: 'sans-serif',
    variants: [
      'regular',
      'italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v3',
    lastModified: '2019-04-29',
  },
  {
    popularity: 360,
    newness: 739,
    style: 377,
    trending: 377,
    alphaIndex: 61,
    family: 'Artifika',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 43,
    newness: 885,
    style: 164,
    trending: 164,
    alphaIndex: 62,
    family: 'Arvo',
    category: 'serif',
    variants: [
      'regular',
      'italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin',
    ],
    version: 'v11',
    lastModified: '2019-05-01',
  },
  {
    popularity: 669,
    newness: 207,
    style: 252,
    trending: 252,
    alphaIndex: 63,
    family: 'Arya',
    category: 'sans-serif',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'devanagari',
    ],
    version: 'v4',
    lastModified: '2019-04-18',
  },
  {
    popularity: 65,
    newness: 468,
    style: 72,
    trending: 72,
    alphaIndex: 64,
    family: 'Asap',
    category: 'sans-serif',
    variants: [
      'regular',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-05-01',
  },
  {
    popularity: 205,
    newness: 71,
    style: 73,
    trending: 73,
    alphaIndex: 65,
    family: 'Asap Condensed',
    category: 'sans-serif',
    variants: [
      'regular',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v3',
    lastModified: '2019-04-29',
  },
  {
    popularity: 778,
    newness: 196,
    style: 378,
    trending: 378,
    alphaIndex: 66,
    family: 'Asar',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'devanagari',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 786,
    newness: 726,
    style: 379,
    trending: 379,
    alphaIndex: 67,
    family: 'Asset',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-18',
  },
  {
    popularity: 92,
    newness: 171,
    style: 107,
    trending: 107,
    alphaIndex: 68,
    family: 'Assistant',
    category: 'sans-serif',
    variants: [
      '200',
      '300',
      'regular',
      '600',
      '700',
      '800',
    ],
    subsets: [
      'latin',
      'hebrew',
    ],
    version: 'v3',
    lastModified: '2019-04-29',
  },
  {
    popularity: 745,
    newness: 827,
    style: 253,
    trending: 253,
    alphaIndex: 69,
    family: 'Astloch',
    category: 'display',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-18',
  },
  {
    popularity: 683,
    newness: 520,
    style: 254,
    trending: 254,
    alphaIndex: 70,
    family: 'Asul',
    category: 'sans-serif',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-18',
  },
  {
    popularity: 477,
    newness: 118,
    style: 108,
    trending: 108,
    alphaIndex: 71,
    family: 'Athiti',
    category: 'sans-serif',
    variants: [
      '200',
      '300',
      'regular',
      '500',
      '600',
      '700',
    ],
    subsets: [
      'latin-ext',
      'thai',
      'vietnamese',
      'latin',
    ],
    version: 'v3',
    lastModified: '2019-04-29',
  },
  {
    popularity: 624,
    newness: 119,
    style: 131,
    trending: 131,
    alphaIndex: 72,
    family: 'Atma',
    category: 'display',
    variants: [
      '300',
      'regular',
      '500',
      '600',
      '700',
    ],
    subsets: [
      'latin-ext',
      'bengali',
      'latin',
    ],
    version: 'v4',
    lastModified: '2019-04-18',
  },
  {
    popularity: 837,
    newness: 634,
    style: 380,
    trending: 380,
    alphaIndex: 73,
    family: 'Atomic Age',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v11',
    lastModified: '2019-04-18',
  },
  {
    popularity: 882,
    newness: 697,
    style: 381,
    trending: 381,
    alphaIndex: 74,
    family: 'Aubrey',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v11',
    lastModified: '2019-04-18',
  },
  {
    popularity: 197,
    newness: 398,
    style: 382,
    trending: 382,
    alphaIndex: 75,
    family: 'Audiowide',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 726,
    newness: 393,
    style: 383,
    trending: 383,
    alphaIndex: 76,
    family: 'Autour One',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-18',
  },
  {
    popularity: 289,
    newness: 416,
    style: 384,
    trending: 384,
    alphaIndex: 77,
    family: 'Average',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 428,
    newness: 324,
    style: 385,
    trending: 385,
    alphaIndex: 78,
    family: 'Average Sans',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 682,
    newness: 417,
    style: 386,
    trending: 386,
    alphaIndex: 79,
    family: 'Averia Gruesa Libre',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 563,
    newness: 418,
    style: 109,
    trending: 109,
    alphaIndex: 80,
    family: 'Averia Libre',
    category: 'display',
    variants: [
      '300',
      '300italic',
      'regular',
      'italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 610,
    newness: 419,
    style: 110,
    trending: 110,
    alphaIndex: 81,
    family: 'Averia Sans Libre',
    category: 'display',
    variants: [
      '300',
      '300italic',
      'regular',
      'italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 458,
    newness: 420,
    style: 111,
    trending: 111,
    alphaIndex: 82,
    family: 'Averia Serif Libre',
    category: 'display',
    variants: [
      '300',
      '300italic',
      'regular',
      'italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 904,
    newness: 1,
    style: 165,
    trending: 165,
    alphaIndex: 0,
    family: 'B612',
    category: 'sans-serif',
    variants: [
      'regular',
      'italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin',
    ],
    version: 'v2',
    lastModified: '2019-01-10',
  },
  {
    popularity: 910,
    newness: 2,
    style: 166,
    trending: 166,
    alphaIndex: 1,
    family: 'B612 Mono',
    category: 'monospace',
    variants: [
      'regular',
      'italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin',
    ],
    version: 'v2',
    lastModified: '2019-01-10',
  },
  {
    popularity: 226,
    newness: 563,
    style: 387,
    trending: 387,
    alphaIndex: 2,
    family: 'Bad Script',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'cyrillic',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 775,
    newness: 104,
    style: 388,
    trending: 388,
    alphaIndex: 3,
    family: 'Bahiana',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v3',
    lastModified: '2019-04-18',
  },
  {
    popularity: 510,
    newness: 13,
    style: 31,
    trending: 31,
    alphaIndex: 4,
    family: 'Bai Jamjuree',
    category: 'sans-serif',
    variants: [
      '200',
      '200italic',
      '300',
      '300italic',
      'regular',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin-ext',
      'thai',
      'vietnamese',
      'latin',
    ],
    version: 'v2',
    lastModified: '2019-04-29',
  },
  {
    popularity: 269,
    newness: 178,
    style: 389,
    trending: 389,
    alphaIndex: 5,
    family: 'Baloo',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
      'devanagari',
    ],
    version: 'v4',
    lastModified: '2019-04-29',
  },
  {
    popularity: 644,
    newness: 179,
    style: 390,
    trending: 390,
    alphaIndex: 6,
    family: 'Baloo Bhai',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'gujarati',
      'vietnamese',
      'latin',
    ],
    version: 'v4',
    lastModified: '2019-04-18',
  },
  {
    popularity: 487,
    newness: 86,
    style: 391,
    trending: 391,
    alphaIndex: 7,
    family: 'Baloo Bhaijaan',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
      'arabic',
    ],
    version: 'v5',
    lastModified: '2019-04-29',
  },
  {
    popularity: 432,
    newness: 180,
    style: 392,
    trending: 392,
    alphaIndex: 8,
    family: 'Baloo Bhaina',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
      'oriya',
    ],
    version: 'v4',
    lastModified: '2019-04-29',
  },
  {
    popularity: 564,
    newness: 181,
    style: 393,
    trending: 393,
    alphaIndex: 9,
    family: 'Baloo Chettan',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'malayalam',
      'latin',
    ],
    version: 'v4',
    lastModified: '2019-04-29',
  },
  {
    popularity: 830,
    newness: 182,
    style: 394,
    trending: 394,
    alphaIndex: 10,
    family: 'Baloo Da',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'bengali',
      'latin',
    ],
    version: 'v4',
    lastModified: '2019-04-18',
  },
  {
    popularity: 536,
    newness: 183,
    style: 395,
    trending: 395,
    alphaIndex: 11,
    family: 'Baloo Paaji',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'gurmukhi',
      'latin',
    ],
    version: 'v5',
    lastModified: '2019-04-18',
  },
  {
    popularity: 679,
    newness: 184,
    style: 396,
    trending: 396,
    alphaIndex: 12,
    family: 'Baloo Tamma',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
      'kannada',
    ],
    version: 'v5',
    lastModified: '2019-04-18',
  },
  {
    popularity: 760,
    newness: 185,
    style: 397,
    trending: 397,
    alphaIndex: 13,
    family: 'Baloo Tammudu',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'telugu',
      'vietnamese',
      'latin',
    ],
    version: 'v5',
    lastModified: '2019-04-18',
  },
  {
    popularity: 663,
    newness: 186,
    style: 398,
    trending: 398,
    alphaIndex: 14,
    family: 'Baloo Thambi',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
      'tamil',
    ],
    version: 'v4',
    lastModified: '2019-04-18',
  },
  {
    popularity: 436,
    newness: 564,
    style: 399,
    trending: 399,
    alphaIndex: 15,
    family: 'Balthazar',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 159,
    newness: 829,
    style: 400,
    trending: 400,
    alphaIndex: 16,
    family: 'Bangers',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v11',
    lastModified: '2019-04-29',
  },
  {
    popularity: 71,
    newness: 62,
    style: 0,
    trending: 0,
    alphaIndex: 17,
    family: 'Barlow',
    category: 'sans-serif',
    variants: [
      '100',
      '100italic',
      '200',
      '200italic',
      '300',
      '300italic',
      'regular',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
      '900',
      '900italic',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v3',
    lastModified: '2019-05-01',
  },
  {
    popularity: 129,
    newness: 63,
    style: 1,
    trending: 1,
    alphaIndex: 18,
    family: 'Barlow Condensed',
    category: 'sans-serif',
    variants: [
      '100',
      '100italic',
      '200',
      '200italic',
      '300',
      '300italic',
      'regular',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
      '900',
      '900italic',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v3',
    lastModified: '2019-04-29',
  },
  {
    popularity: 141,
    newness: 64,
    style: 2,
    trending: 2,
    alphaIndex: 19,
    family: 'Barlow Semi Condensed',
    category: 'sans-serif',
    variants: [
      '100',
      '100italic',
      '200',
      '200italic',
      '300',
      '300italic',
      'regular',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
      '900',
      '900italic',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v4',
    lastModified: '2019-04-29',
  },
  {
    popularity: 747,
    newness: 105,
    style: 401,
    trending: 401,
    alphaIndex: 20,
    family: 'Barrio',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v3',
    lastModified: '2019-04-18',
  },
  {
    popularity: 287,
    newness: 561,
    style: 402,
    trending: 402,
    alphaIndex: 21,
    family: 'Basic',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 582,
    newness: 807,
    style: 255,
    trending: 255,
    alphaIndex: 22,
    family: 'Battambang',
    category: 'display',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'khmer',
    ],
    version: 'v12',
    lastModified: '2019-04-18',
  },
  {
    popularity: 502,
    newness: 576,
    style: 403,
    trending: 403,
    alphaIndex: 23,
    family: 'Baumans',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 846,
    newness: 808,
    style: 404,
    trending: 404,
    alphaIndex: 24,
    family: 'Bayon',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'khmer',
    ],
    version: 'v12',
    lastModified: '2019-04-18',
  },
  {
    popularity: 517,
    newness: 521,
    style: 405,
    trending: 405,
    alphaIndex: 25,
    family: 'Belgrano',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 590,
    newness: 84,
    style: 406,
    trending: 406,
    alphaIndex: 26,
    family: 'Bellefair',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'hebrew',
    ],
    version: 'v4',
    lastModified: '2019-04-18',
  },
  {
    popularity: 323,
    newness: 406,
    style: 407,
    trending: 407,
    alphaIndex: 27,
    family: 'Belleza',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 154,
    newness: 347,
    style: 219,
    trending: 219,
    alphaIndex: 28,
    family: 'BenchNine',
    category: 'sans-serif',
    variants: [
      '300',
      'regular',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 473,
    newness: 878,
    style: 408,
    trending: 408,
    alphaIndex: 29,
    family: 'Bentham',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 355,
    newness: 421,
    style: 409,
    trending: 409,
    alphaIndex: 30,
    family: 'Berkshire Swash',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 276,
    newness: 826,
    style: 410,
    trending: 410,
    alphaIndex: 31,
    family: 'Bevan',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 874,
    newness: 304,
    style: 411,
    trending: 411,
    alphaIndex: 32,
    family: 'Bigelow Rules',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 791,
    newness: 759,
    style: 412,
    trending: 412,
    alphaIndex: 33,
    family: 'Bigshot One',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-18',
  },
  {
    popularity: 696,
    newness: 577,
    style: 413,
    trending: 413,
    alphaIndex: 34,
    family: 'Bilbo',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-18',
  },
  {
    popularity: 496,
    newness: 565,
    style: 414,
    trending: 414,
    alphaIndex: 35,
    family: 'Bilbo Swash Caps',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v11',
    lastModified: '2019-04-29',
  },
  {
    popularity: 639,
    newness: 175,
    style: 132,
    trending: 132,
    alphaIndex: 36,
    family: 'BioRhyme',
    category: 'serif',
    variants: [
      '200',
      '300',
      'regular',
      '700',
      '800',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v3',
    lastModified: '2019-04-18',
  },
  {
    popularity: 896,
    newness: 120,
    style: 133,
    trending: 133,
    alphaIndex: 37,
    family: 'BioRhyme Expanded',
    category: 'serif',
    variants: [
      '200',
      '300',
      'regular',
      '700',
      '800',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v4',
    lastModified: '2019-04-18',
  },
  {
    popularity: 305,
    newness: 212,
    style: 85,
    trending: 85,
    alphaIndex: 38,
    family: 'Biryani',
    category: 'sans-serif',
    variants: [
      '200',
      '300',
      'regular',
      '600',
      '700',
      '800',
      '900',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'devanagari',
    ],
    version: 'v4',
    lastModified: '2019-04-29',
  },
  {
    popularity: 41,
    newness: 522,
    style: 220,
    trending: 220,
    alphaIndex: 39,
    family: 'Bitter',
    category: 'serif',
    variants: [
      'regular',
      'italic',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v14',
    lastModified: '2019-05-01',
  },
  {
    popularity: 877,
    newness: 40,
    style: 415,
    trending: 415,
    alphaIndex: 40,
    family: 'Black And White Picture',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'korean',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 435,
    newness: 47,
    style: 416,
    trending: 416,
    alphaIndex: 41,
    family: 'Black Han Sans',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'korean',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 278,
    newness: 698,
    style: 417,
    trending: 417,
    alphaIndex: 42,
    family: 'Black Ops One',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 782,
    newness: 809,
    style: 418,
    trending: 418,
    alphaIndex: 43,
    family: 'Bokor',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'khmer',
    ],
    version: 'v11',
    lastModified: '2019-04-18',
  },
  {
    popularity: 895,
    newness: 578,
    style: 419,
    trending: 419,
    alphaIndex: 44,
    family: 'Bonbon',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-18',
  },
  {
    popularity: 181,
    newness: 523,
    style: 420,
    trending: 420,
    alphaIndex: 45,
    family: 'Boogaloo',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 479,
    newness: 713,
    style: 421,
    trending: 421,
    alphaIndex: 46,
    family: 'Bowlby One',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 334,
    newness: 719,
    style: 422,
    trending: 422,
    alphaIndex: 47,
    family: 'Bowlby One SC',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 523,
    newness: 744,
    style: 423,
    trending: 423,
    alphaIndex: 48,
    family: 'Brawler',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 68,
    newness: 524,
    style: 424,
    trending: 424,
    alphaIndex: 49,
    family: 'Bree Serif',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-05-01',
  },
  {
    popularity: 405,
    newness: 609,
    style: 425,
    trending: 425,
    alphaIndex: 50,
    family: 'Bubblegum Sans',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 623,
    newness: 394,
    style: 426,
    trending: 426,
    alphaIndex: 51,
    family: 'Bubbler One',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 677,
    newness: 855,
    style: 427,
    trending: 427,
    alphaIndex: 52,
    family: 'Buda',
    category: 'display',
    variants: [
      '300',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-18',
  },
  {
    popularity: 310,
    newness: 525,
    style: 256,
    trending: 256,
    alphaIndex: 53,
    family: 'Buenard',
    category: 'serif',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 385,
    newness: 121,
    style: 428,
    trending: 428,
    alphaIndex: 54,
    family: 'Bungee',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v4',
    lastModified: '2019-04-29',
  },
  {
    popularity: 864,
    newness: 122,
    style: 429,
    trending: 429,
    alphaIndex: 55,
    family: 'Bungee Hairline',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v4',
    lastModified: '2019-04-18',
  },
  {
    popularity: 381,
    newness: 123,
    style: 430,
    trending: 430,
    alphaIndex: 56,
    family: 'Bungee Inline',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v4',
    lastModified: '2019-04-29',
  },
  {
    popularity: 860,
    newness: 124,
    style: 431,
    trending: 431,
    alphaIndex: 57,
    family: 'Bungee Outline',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v4',
    lastModified: '2019-04-18',
  },
  {
    popularity: 570,
    newness: 125,
    style: 432,
    trending: 432,
    alphaIndex: 58,
    family: 'Bungee Shade',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v4',
    lastModified: '2019-04-18',
  },
  {
    popularity: 886,
    newness: 526,
    style: 433,
    trending: 433,
    alphaIndex: 59,
    family: 'Butcherman',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-18',
  },
  {
    popularity: 865,
    newness: 456,
    style: 434,
    trending: 434,
    alphaIndex: 60,
    family: 'Butterfly Kids',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 44,
    newness: 790,
    style: 74,
    trending: 74,
    alphaIndex: 0,
    family: 'Cabin',
    category: 'sans-serif',
    variants: [
      'regular',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v13',
    lastModified: '2019-05-01',
  },
  {
    popularity: 174,
    newness: 595,
    style: 167,
    trending: 167,
    alphaIndex: 1,
    family: 'Cabin Condensed',
    category: 'sans-serif',
    variants: [
      'regular',
      '500',
      '600',
      '700',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v12',
    lastModified: '2019-04-29',
  },
  {
    popularity: 317,
    newness: 799,
    style: 257,
    trending: 257,
    alphaIndex: 2,
    family: 'Cabin Sketch',
    category: 'display',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin',
    ],
    version: 'v12',
    lastModified: '2019-04-29',
  },
  {
    popularity: 822,
    newness: 527,
    style: 435,
    trending: 435,
    alphaIndex: 3,
    family: 'Caesar Dressing',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 667,
    newness: 596,
    style: 436,
    trending: 436,
    alphaIndex: 4,
    family: 'Cagliostro',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 80,
    newness: 126,
    style: 112,
    trending: 112,
    alphaIndex: 5,
    family: 'Cairo',
    category: 'sans-serif',
    variants: [
      '200',
      '300',
      'regular',
      '600',
      '700',
      '900',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'arabic',
    ],
    version: 'v5',
    lastModified: '2019-05-01',
  },
  {
    popularity: 397,
    newness: 839,
    style: 437,
    trending: 437,
    alphaIndex: 6,
    family: 'Calligraffitti',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 470,
    newness: 220,
    style: 168,
    trending: 168,
    alphaIndex: 7,
    family: 'Cambay',
    category: 'sans-serif',
    variants: [
      'regular',
      'italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'devanagari',
    ],
    version: 'v5',
    lastModified: '2019-04-29',
  },
  {
    popularity: 386,
    newness: 528,
    style: 438,
    trending: 438,
    alphaIndex: 8,
    family: 'Cambo',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 284,
    newness: 802,
    style: 439,
    trending: 439,
    alphaIndex: 9,
    family: 'Candal',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 106,
    newness: 910,
    style: 169,
    trending: 169,
    alphaIndex: 10,
    family: 'Cantarell',
    category: 'sans-serif',
    variants: [
      'regular',
      'italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 248,
    newness: 438,
    style: 440,
    trending: 440,
    alphaIndex: 11,
    family: 'Cantata One',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 559,
    newness: 382,
    style: 441,
    trending: 441,
    alphaIndex: 12,
    family: 'Cantora One',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 442,
    newness: 388,
    style: 442,
    trending: 442,
    alphaIndex: 13,
    family: 'Capriola',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 113,
    newness: 658,
    style: 221,
    trending: 221,
    alphaIndex: 14,
    family: 'Cardo',
    category: 'serif',
    variants: [
      'regular',
      'italic',
      '700',
    ],
    subsets: [
      'greek',
      'greek-ext',
      'latin-ext',
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 352,
    newness: 699,
    style: 443,
    trending: 443,
    alphaIndex: 15,
    family: 'Carme',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 368,
    newness: 343,
    style: 444,
    trending: 444,
    alphaIndex: 16,
    family: 'Carrois Gothic',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 497,
    newness: 344,
    style: 445,
    trending: 445,
    alphaIndex: 17,
    family: 'Carrois Gothic SC',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 211,
    newness: 760,
    style: 446,
    trending: 446,
    alphaIndex: 18,
    family: 'Carter One',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 73,
    newness: 191,
    style: 56,
    trending: 56,
    alphaIndex: 19,
    family: 'Catamaran',
    category: 'sans-serif',
    variants: [
      '100',
      '200',
      '300',
      'regular',
      '500',
      '600',
      '700',
      '800',
      '900',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'tamil',
    ],
    version: 'v5',
    lastModified: '2019-05-01',
  },
  {
    popularity: 393,
    newness: 745,
    style: 170,
    trending: 170,
    alphaIndex: 20,
    family: 'Caudex',
    category: 'serif',
    variants: [
      'regular',
      'italic',
      '700',
      '700italic',
    ],
    subsets: [
      'greek',
      'greek-ext',
      'latin-ext',
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 112,
    newness: 188,
    style: 258,
    trending: 258,
    alphaIndex: 21,
    family: 'Caveat',
    category: 'handwriting',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'latin',
    ],
    version: 'v5',
    lastModified: '2019-04-29',
  },
  {
    popularity: 333,
    newness: 189,
    style: 447,
    trending: 447,
    alphaIndex: 22,
    family: 'Caveat Brush',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v4',
    lastModified: '2019-04-29',
  },
  {
    popularity: 460,
    newness: 734,
    style: 448,
    trending: 448,
    alphaIndex: 23,
    family: 'Cedarville Cursive',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 394,
    newness: 579,
    style: 449,
    trending: 449,
    alphaIndex: 24,
    family: 'Ceviche One',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 678,
    newness: 14,
    style: 43,
    trending: 43,
    alphaIndex: 25,
    family: 'Chakra Petch',
    category: 'sans-serif',
    variants: [
      '300',
      '300italic',
      'regular',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin-ext',
      'thai',
      'vietnamese',
      'latin',
    ],
    version: 'v2',
    lastModified: '2019-04-18',
  },
  {
    popularity: 187,
    newness: 127,
    style: 86,
    trending: 86,
    alphaIndex: 26,
    family: 'Changa',
    category: 'sans-serif',
    variants: [
      '200',
      '300',
      'regular',
      '500',
      '600',
      '700',
      '800',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'arabic',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 348,
    newness: 597,
    style: 259,
    trending: 259,
    alphaIndex: 27,
    family: 'Changa One',
    category: 'display',
    variants: [
      'regular',
      'italic',
    ],
    subsets: [
      'latin',
    ],
    version: 'v11',
    lastModified: '2019-04-29',
  },
  {
    popularity: 783,
    newness: 566,
    style: 450,
    trending: 450,
    alphaIndex: 28,
    family: 'Chango',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 575,
    newness: 3,
    style: 260,
    trending: 260,
    alphaIndex: 29,
    family: 'Charm',
    category: 'handwriting',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin-ext',
      'thai',
      'vietnamese',
      'latin',
    ],
    version: 'v3',
    lastModified: '2019-04-18',
  },
  {
    popularity: 807,
    newness: 15,
    style: 261,
    trending: 261,
    alphaIndex: 30,
    family: 'Charmonman',
    category: 'handwriting',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin-ext',
      'thai',
      'vietnamese',
      'latin',
    ],
    version: 'v2',
    lastModified: '2019-04-18',
  },
  {
    popularity: 777,
    newness: 128,
    style: 134,
    trending: 134,
    alphaIndex: 31,
    family: 'Chathura',
    category: 'sans-serif',
    variants: [
      '100',
      '300',
      'regular',
      '700',
      '800',
    ],
    subsets: [
      'telugu',
      'latin',
    ],
    version: 'v4',
    lastModified: '2019-04-18',
  },
  {
    popularity: 607,
    newness: 399,
    style: 262,
    trending: 262,
    alphaIndex: 32,
    family: 'Chau Philomene One',
    category: 'sans-serif',
    variants: [
      'regular',
      'italic',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-18',
  },
  {
    popularity: 664,
    newness: 337,
    style: 451,
    trending: 451,
    alphaIndex: 33,
    family: 'Chela One',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 451,
    newness: 509,
    style: 452,
    trending: 452,
    alphaIndex: 34,
    family: 'Chelsea Market',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 907,
    newness: 810,
    style: 453,
    trending: 453,
    alphaIndex: 35,
    family: 'Chenla',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'khmer',
    ],
    version: 'v11',
    lastModified: '2019-04-18',
  },
  {
    popularity: 636,
    newness: 840,
    style: 454,
    trending: 454,
    alphaIndex: 36,
    family: 'Cherry Cream Soda',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-18',
  },
  {
    popularity: 551,
    newness: 333,
    style: 263,
    trending: 263,
    alphaIndex: 37,
    family: 'Cherry Swash',
    category: 'display',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 256,
    newness: 841,
    style: 455,
    trending: 455,
    alphaIndex: 38,
    family: 'Chewy',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 614,
    newness: 598,
    style: 456,
    trending: 456,
    alphaIndex: 39,
    family: 'Chicle',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 140,
    newness: 580,
    style: 75,
    trending: 75,
    alphaIndex: 40,
    family: 'Chivo',
    category: 'sans-serif',
    variants: [
      '300',
      '300italic',
      'regular',
      'italic',
      '700',
      '700italic',
      '900',
      '900italic',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 565,
    newness: 192,
    style: 457,
    trending: 457,
    alphaIndex: 41,
    family: 'Chonburi',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'thai',
      'vietnamese',
      'latin',
    ],
    version: 'v3',
    lastModified: '2019-04-29',
  },
  {
    popularity: 84,
    newness: 334,
    style: 222,
    trending: 222,
    alphaIndex: 42,
    family: 'Cinzel',
    category: 'serif',
    variants: [
      'regular',
      '700',
      '900',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-05-01',
  },
  {
    popularity: 332,
    newness: 335,
    style: 223,
    trending: 223,
    alphaIndex: 43,
    family: 'Cinzel Decorative',
    category: 'display',
    variants: [
      'regular',
      '700',
      '900',
    ],
    subsets: [
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 514,
    newness: 301,
    style: 458,
    trending: 458,
    alphaIndex: 44,
    family: 'Clicker Script',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 288,
    newness: 872,
    style: 264,
    trending: 264,
    alphaIndex: 45,
    family: 'Coda',
    category: 'display',
    variants: [
      'regular',
      '800',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v14',
    lastModified: '2019-04-29',
  },
  {
    popularity: 475,
    newness: 830,
    style: 459,
    trending: 459,
    alphaIndex: 46,
    family: 'Coda Caption',
    category: 'sans-serif',
    variants: [
      '800',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v12',
    lastModified: '2019-04-29',
  },
  {
    popularity: 584,
    newness: 422,
    style: 265,
    trending: 265,
    alphaIndex: 47,
    family: 'Codystar',
    category: 'display',
    variants: [
      '300',
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 648,
    newness: 111,
    style: 460,
    trending: 460,
    alphaIndex: 48,
    family: 'Coiny',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
      'tamil',
    ],
    version: 'v4',
    lastModified: '2019-04-18',
  },
  {
    popularity: 866,
    newness: 350,
    style: 461,
    trending: 461,
    alphaIndex: 49,
    family: 'Combo',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 78,
    newness: 684,
    style: 135,
    trending: 135,
    alphaIndex: 50,
    family: 'Comfortaa',
    category: 'display',
    variants: [
      '300',
      'regular',
      '500',
      '600',
      '700',
    ],
    subsets: [
      'greek',
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v22',
    lastModified: '2019-05-01',
  },
  {
    popularity: 314,
    newness: 842,
    style: 462,
    trending: 462,
    alphaIndex: 51,
    family: 'Coming Soon',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 120,
    newness: 610,
    style: 463,
    trending: 463,
    alphaIndex: 52,
    family: 'Concert One',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 654,
    newness: 469,
    style: 464,
    trending: 464,
    alphaIndex: 53,
    family: 'Condiment',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 797,
    newness: 811,
    style: 266,
    trending: 266,
    alphaIndex: 54,
    family: 'Content',
    category: 'display',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'khmer',
    ],
    version: 'v11',
    lastModified: '2019-04-18',
  },
  {
    popularity: 392,
    newness: 635,
    style: 465,
    trending: 465,
    alphaIndex: 55,
    family: 'Contrail One',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 534,
    newness: 623,
    style: 466,
    trending: 466,
    alphaIndex: 56,
    family: 'Convergence',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 132,
    newness: 640,
    style: 467,
    trending: 467,
    alphaIndex: 57,
    family: 'Cookie',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 346,
    newness: 864,
    style: 468,
    trending: 468,
    alphaIndex: 58,
    family: 'Copse',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 459,
    newness: 856,
    style: 267,
    trending: 267,
    alphaIndex: 59,
    family: 'Corben',
    category: 'display',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v12',
    lastModified: '2019-04-29',
  },
  {
    popularity: 252,
    newness: 129,
    style: 44,
    trending: 44,
    alphaIndex: 60,
    family: 'Cormorant',
    category: 'serif',
    variants: [
      '300',
      '300italic',
      'regular',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 114,
    newness: 130,
    style: 45,
    trending: 45,
    alphaIndex: 61,
    family: 'Cormorant Garamond',
    category: 'serif',
    variants: [
      '300',
      '300italic',
      'regular',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 492,
    newness: 131,
    style: 46,
    trending: 46,
    alphaIndex: 62,
    family: 'Cormorant Infant',
    category: 'serif',
    variants: [
      '300',
      '300italic',
      'regular',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 462,
    newness: 132,
    style: 136,
    trending: 136,
    alphaIndex: 63,
    family: 'Cormorant SC',
    category: 'serif',
    variants: [
      '300',
      'regular',
      '500',
      '600',
      '700',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 616,
    newness: 133,
    style: 137,
    trending: 137,
    alphaIndex: 64,
    family: 'Cormorant Unicase',
    category: 'serif',
    variants: [
      '300',
      'regular',
      '500',
      '600',
      '700',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 649,
    newness: 134,
    style: 138,
    trending: 138,
    alphaIndex: 65,
    family: 'Cormorant Upright',
    category: 'serif',
    variants: [
      '300',
      'regular',
      '500',
      '600',
      '700',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v5',
    lastModified: '2019-04-18',
  },
  {
    popularity: 109,
    newness: 389,
    style: 469,
    trending: 469,
    alphaIndex: 66,
    family: 'Courgette',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 212,
    newness: 883,
    style: 171,
    trending: 171,
    alphaIndex: 67,
    family: 'Cousine',
    category: 'monospace',
    variants: [
      'regular',
      'italic',
      '700',
      '700italic',
    ],
    subsets: [
      'greek',
      'greek-ext',
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
      'hebrew',
    ],
    version: 'v13',
    lastModified: '2019-04-29',
  },
  {
    popularity: 351,
    newness: 685,
    style: 268,
    trending: 268,
    alphaIndex: 68,
    family: 'Coustard',
    category: 'serif',
    variants: [
      'regular',
      '900',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 239,
    newness: 873,
    style: 470,
    trending: 470,
    alphaIndex: 69,
    family: 'Covered By Your Grace',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 515,
    newness: 843,
    style: 471,
    trending: 471,
    alphaIndex: 70,
    family: 'Crafty Girls',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 593,
    newness: 529,
    style: 472,
    trending: 472,
    alphaIndex: 71,
    family: 'Creepster',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 93,
    newness: 530,
    style: 269,
    trending: 269,
    alphaIndex: 72,
    family: 'Crete Round',
    category: 'serif',
    variants: [
      'regular',
      'italic',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-05-01',
  },
  {
    popularity: 38,
    newness: 838,
    style: 113,
    trending: 113,
    alphaIndex: 73,
    family: 'Crimson Text',
    category: 'serif',
    variants: [
      'regular',
      'italic',
      '600',
      '600italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-05-01',
  },
  {
    popularity: 731,
    newness: 299,
    style: 473,
    trending: 473,
    alphaIndex: 74,
    family: 'Croissant One',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 538,
    newness: 844,
    style: 474,
    trending: 474,
    alphaIndex: 75,
    family: 'Crushed',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-18',
  },
  {
    popularity: 104,
    newness: 400,
    style: 172,
    trending: 172,
    alphaIndex: 76,
    family: 'Cuprum',
    category: 'sans-serif',
    variants: [
      'regular',
      'italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 901,
    newness: 48,
    style: 475,
    trending: 475,
    alphaIndex: 77,
    family: 'Cute Font',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'korean',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 412,
    newness: 439,
    style: 476,
    trending: 476,
    alphaIndex: 78,
    family: 'Cutive',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 407,
    newness: 325,
    style: 477,
    trending: 477,
    alphaIndex: 79,
    family: 'Cutive Mono',
    category: 'monospace',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 244,
    newness: 772,
    style: 478,
    trending: 478,
    alphaIndex: 0,
    family: 'Damion',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 58,
    newness: 746,
    style: 270,
    trending: 270,
    alphaIndex: 1,
    family: 'Dancing Script',
    category: 'handwriting',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-05-01',
  },
  {
    popularity: 812,
    newness: 812,
    style: 479,
    trending: 479,
    alphaIndex: 2,
    family: 'Dangrek',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'khmer',
    ],
    version: 'v10',
    lastModified: '2019-04-18',
  },
  {
    popularity: 573,
    newness: 135,
    style: 224,
    trending: 224,
    alphaIndex: 3,
    family: 'David Libre',
    category: 'serif',
    variants: [
      'regular',
      '500',
      '700',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
      'hebrew',
    ],
    version: 'v3',
    lastModified: '2019-04-18',
  },
  {
    popularity: 547,
    newness: 783,
    style: 480,
    trending: 480,
    alphaIndex: 4,
    family: 'Dawning of a New Day',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 251,
    newness: 674,
    style: 481,
    trending: 481,
    alphaIndex: 5,
    family: 'Days One',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 630,
    newness: 221,
    style: 482,
    trending: 482,
    alphaIndex: 6,
    family: 'Dekko',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'devanagari',
    ],
    version: 'v5',
    lastModified: '2019-04-18',
  },
  {
    popularity: 365,
    newness: 700,
    style: 483,
    trending: 483,
    alphaIndex: 7,
    family: 'Delius',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 553,
    newness: 691,
    style: 484,
    trending: 484,
    alphaIndex: 8,
    family: 'Delius Swash Caps',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 612,
    newness: 641,
    style: 271,
    trending: 271,
    alphaIndex: 9,
    family: 'Delius Unicase',
    category: 'handwriting',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin',
    ],
    version: 'v12',
    lastModified: '2019-04-18',
  },
  {
    popularity: 759,
    newness: 401,
    style: 485,
    trending: 485,
    alphaIndex: 10,
    family: 'Della Respira',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 532,
    newness: 280,
    style: 486,
    trending: 486,
    alphaIndex: 11,
    family: 'Denk One',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 824,
    newness: 620,
    style: 487,
    trending: 487,
    alphaIndex: 12,
    family: 'Devonshire',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 905,
    newness: 234,
    style: 488,
    trending: 488,
    alphaIndex: 13,
    family: 'Dhurjati',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'telugu',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 143,
    newness: 761,
    style: 489,
    trending: 489,
    alphaIndex: 14,
    family: 'Didact Gothic',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'greek',
      'greek-ext',
      'latin-ext',
      'cyrillic',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v12',
    lastModified: '2019-04-29',
  },
  {
    popularity: 714,
    newness: 470,
    style: 490,
    trending: 490,
    alphaIndex: 15,
    family: 'Diplomata',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-18',
  },
  {
    popularity: 754,
    newness: 471,
    style: 491,
    trending: 491,
    alphaIndex: 16,
    family: 'Diplomata SC',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 400,
    newness: 43,
    style: 492,
    trending: 492,
    alphaIndex: 17,
    family: 'Do Hyeon',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'korean',
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 733,
    newness: 49,
    style: 493,
    trending: 493,
    alphaIndex: 18,
    family: 'Dokdo',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'korean',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 94,
    newness: 285,
    style: 272,
    trending: 272,
    alphaIndex: 19,
    family: 'Domine',
    category: 'serif',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-05-01',
  },
  {
    popularity: 661,
    newness: 281,
    style: 494,
    trending: 494,
    alphaIndex: 20,
    family: 'Donegal One',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 466,
    newness: 448,
    style: 495,
    trending: 495,
    alphaIndex: 21,
    family: 'Doppio One',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 705,
    newness: 666,
    style: 496,
    trending: 496,
    alphaIndex: 22,
    family: 'Dorsa',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-18',
  },
  {
    popularity: 35,
    newness: 412,
    style: 87,
    trending: 87,
    alphaIndex: 23,
    family: 'Dosis',
    category: 'sans-serif',
    variants: [
      '200',
      '300',
      'regular',
      '500',
      '600',
      '700',
      '800',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-05-01',
  },
  {
    popularity: 742,
    newness: 599,
    style: 497,
    trending: 497,
    alphaIndex: 24,
    family: 'Dr Sugiyama',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-18',
  },
  {
    popularity: 401,
    newness: 531,
    style: 498,
    trending: 498,
    alphaIndex: 25,
    family: 'Duru Sans',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v12',
    lastModified: '2019-04-29',
  },
  {
    popularity: 617,
    newness: 532,
    style: 499,
    trending: 499,
    alphaIndex: 26,
    family: 'Dynalight',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 70,
    newness: 791,
    style: 47,
    trending: 47,
    alphaIndex: 0,
    family: 'EB Garamond',
    category: 'serif',
    variants: [
      'regular',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
    ],
    subsets: [
      'greek',
      'greek-ext',
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v10',
    lastModified: '2019-05-01',
  },
  {
    popularity: 743,
    newness: 384,
    style: 500,
    trending: 500,
    alphaIndex: 1,
    family: 'Eagle Lake',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 842,
    newness: 33,
    style: 501,
    trending: 501,
    alphaIndex: 2,
    family: 'East Sea Dokdo',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'korean',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 589,
    newness: 533,
    style: 502,
    trending: 502,
    alphaIndex: 3,
    family: 'Eater',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 146,
    newness: 440,
    style: 173,
    trending: 173,
    alphaIndex: 4,
    family: 'Economica',
    category: 'sans-serif',
    variants: [
      'regular',
      'italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 416,
    newness: 201,
    style: 139,
    trending: 139,
    alphaIndex: 5,
    family: 'Eczar',
    category: 'serif',
    variants: [
      'regular',
      '500',
      '600',
      '700',
      '800',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'devanagari',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 245,
    newness: 167,
    style: 174,
    trending: 174,
    alphaIndex: 6,
    family: 'El Messiri',
    category: 'sans-serif',
    variants: [
      'regular',
      '500',
      '600',
      '700',
    ],
    subsets: [
      'cyrillic',
      'latin',
      'arabic',
    ],
    version: 'v5',
    lastModified: '2019-04-29',
  },
  {
    popularity: 302,
    newness: 581,
    style: 503,
    trending: 503,
    alphaIndex: 7,
    family: 'Electrolize',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 634,
    newness: 282,
    style: 273,
    trending: 273,
    alphaIndex: 8,
    family: 'Elsie',
    category: 'display',
    variants: [
      'regular',
      '900',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-18',
  },
  {
    popularity: 770,
    newness: 283,
    style: 274,
    trending: 274,
    alphaIndex: 9,
    family: 'Elsie Swash Caps',
    category: 'display',
    variants: [
      'regular',
      '900',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 897,
    newness: 480,
    style: 504,
    trending: 504,
    alphaIndex: 10,
    family: 'Emblema One',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 457,
    newness: 441,
    style: 505,
    trending: 505,
    alphaIndex: 11,
    family: 'Emilys Candy',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 325,
    newness: 91,
    style: 57,
    trending: 57,
    alphaIndex: 12,
    family: 'Encode Sans',
    category: 'sans-serif',
    variants: [
      '100',
      '200',
      '300',
      'regular',
      '500',
      '600',
      '700',
      '800',
      '900',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v3',
    lastModified: '2019-04-29',
  },
  {
    popularity: 235,
    newness: 92,
    style: 58,
    trending: 58,
    alphaIndex: 13,
    family: 'Encode Sans Condensed',
    category: 'sans-serif',
    variants: [
      '100',
      '200',
      '300',
      'regular',
      '500',
      '600',
      '700',
      '800',
      '900',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v3',
    lastModified: '2019-04-29',
  },
  {
    popularity: 625,
    newness: 93,
    style: 59,
    trending: 59,
    alphaIndex: 14,
    family: 'Encode Sans Expanded',
    category: 'sans-serif',
    variants: [
      '100',
      '200',
      '300',
      'regular',
      '500',
      '600',
      '700',
      '800',
      '900',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v3',
    lastModified: '2019-04-18',
  },
  {
    popularity: 647,
    newness: 94,
    style: 60,
    trending: 60,
    alphaIndex: 15,
    family: 'Encode Sans Semi Condensed',
    category: 'sans-serif',
    variants: [
      '100',
      '200',
      '300',
      'regular',
      '500',
      '600',
      '700',
      '800',
      '900',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v3',
    lastModified: '2019-04-18',
  },
  {
    popularity: 640,
    newness: 95,
    style: 61,
    trending: 61,
    alphaIndex: 16,
    family: 'Encode Sans Semi Expanded',
    category: 'sans-serif',
    variants: [
      '100',
      '200',
      '300',
      'regular',
      '500',
      '600',
      '700',
      '800',
      '900',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v4',
    lastModified: '2019-04-18',
  },
  {
    popularity: 638,
    newness: 582,
    style: 506,
    trending: 506,
    alphaIndex: 17,
    family: 'Engagement',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-18',
  },
  {
    popularity: 641,
    newness: 305,
    style: 507,
    trending: 507,
    alphaIndex: 18,
    family: 'Englebert',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 208,
    newness: 567,
    style: 275,
    trending: 275,
    alphaIndex: 19,
    family: 'Enriqueta',
    category: 'serif',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 869,
    newness: 481,
    style: 508,
    trending: 508,
    alphaIndex: 20,
    family: 'Erica One',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-18',
  },
  {
    popularity: 645,
    newness: 497,
    style: 509,
    trending: 509,
    alphaIndex: 21,
    family: 'Esteban',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 567,
    newness: 461,
    style: 510,
    trending: 510,
    alphaIndex: 22,
    family: 'Euphoria Script',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 819,
    newness: 462,
    style: 511,
    trending: 511,
    alphaIndex: 23,
    family: 'Ewert',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 72,
    newness: 463,
    style: 3,
    trending: 3,
    alphaIndex: 24,
    family: 'Exo',
    category: 'sans-serif',
    variants: [
      '100',
      '100italic',
      '200',
      '200italic',
      '300',
      '300italic',
      'regular',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
      '900',
      '900italic',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-05-01',
  },
  {
    popularity: 57,
    newness: 261,
    style: 4,
    trending: 4,
    alphaIndex: 25,
    family: 'Exo 2',
    category: 'sans-serif',
    variants: [
      '100',
      '100italic',
      '200',
      '200italic',
      '300',
      '300italic',
      'regular',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
      '900',
      '900italic',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'latin',
    ],
    version: 'v5',
    lastModified: '2019-05-01',
  },
  {
    popularity: 512,
    newness: 762,
    style: 76,
    trending: 76,
    alphaIndex: 26,
    family: 'Expletus Sans',
    category: 'display',
    variants: [
      'regular',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin',
    ],
    version: 'v12',
    lastModified: '2019-04-29',
  },
  {
    popularity: 844,
    newness: 16,
    style: 32,
    trending: 32,
    alphaIndex: 0,
    family: 'Fahkwang',
    category: 'sans-serif',
    variants: [
      '200',
      '200italic',
      '300',
      '300italic',
      'regular',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin-ext',
      'thai',
      'vietnamese',
      'latin',
    ],
    version: 'v2',
    lastModified: '2019-04-18',
  },
  {
    popularity: 480,
    newness: 667,
    style: 276,
    trending: 276,
    alphaIndex: 1,
    family: 'Fanwood Text',
    category: 'serif',
    variants: [
      'regular',
      'italic',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 672,
    newness: 112,
    style: 512,
    trending: 512,
    alphaIndex: 2,
    family: 'Farsan',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'gujarati',
      'vietnamese',
      'latin',
    ],
    version: 'v4',
    lastModified: '2019-04-18',
  },
  {
    popularity: 867,
    newness: 583,
    style: 513,
    trending: 513,
    alphaIndex: 3,
    family: 'Fascinate',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 717,
    newness: 584,
    style: 514,
    trending: 514,
    alphaIndex: 4,
    family: 'Fascinate Inline',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-18',
  },
  {
    popularity: 441,
    newness: 326,
    style: 515,
    trending: 515,
    alphaIndex: 5,
    family: 'Faster One',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 887,
    newness: 392,
    style: 516,
    trending: 516,
    alphaIndex: 6,
    family: 'Fasthand',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'khmer',
    ],
    version: 'v9',
    lastModified: '2019-04-18',
  },
  {
    popularity: 309,
    newness: 265,
    style: 517,
    trending: 517,
    alphaIndex: 7,
    family: 'Fauna One',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 485,
    newness: 72,
    style: 77,
    trending: 77,
    alphaIndex: 8,
    family: 'Faustina',
    category: 'serif',
    variants: [
      'regular',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v3',
    lastModified: '2019-04-29',
  },
  {
    popularity: 863,
    newness: 650,
    style: 518,
    trending: 518,
    alphaIndex: 9,
    family: 'Federant',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-18',
  },
  {
    popularity: 469,
    newness: 701,
    style: 519,
    trending: 519,
    alphaIndex: 10,
    family: 'Federo',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 809,
    newness: 464,
    style: 520,
    trending: 520,
    alphaIndex: 11,
    family: 'Felipa',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 680,
    newness: 348,
    style: 521,
    trending: 521,
    alphaIndex: 12,
    family: 'Fenix',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 580,
    newness: 345,
    style: 522,
    trending: 522,
    alphaIndex: 13,
    family: 'Finger Paint',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-18',
  },
  {
    popularity: 347,
    newness: 253,
    style: 225,
    trending: 225,
    alphaIndex: 14,
    family: 'Fira Mono',
    category: 'monospace',
    variants: [
      'regular',
      '500',
      '700',
    ],
    subsets: [
      'greek',
      'greek-ext',
      'latin-ext',
      'cyrillic',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 27,
    newness: 254,
    style: 5,
    trending: 5,
    alphaIndex: 15,
    family: 'Fira Sans',
    category: 'sans-serif',
    variants: [
      '100',
      '100italic',
      '200',
      '200italic',
      '300',
      '300italic',
      'regular',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
      '900',
      '900italic',
    ],
    subsets: [
      'greek',
      'greek-ext',
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v9',
    lastModified: '2019-05-01',
  },
  {
    popularity: 88,
    newness: 99,
    style: 6,
    trending: 6,
    alphaIndex: 16,
    family: 'Fira Sans Condensed',
    category: 'sans-serif',
    variants: [
      '100',
      '100italic',
      '200',
      '200italic',
      '300',
      '300italic',
      'regular',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
      '900',
      '900italic',
    ],
    subsets: [
      'greek',
      'greek-ext',
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v3',
    lastModified: '2019-05-01',
  },
  {
    popularity: 131,
    newness: 100,
    style: 7,
    trending: 7,
    alphaIndex: 17,
    family: 'Fira Sans Extra Condensed',
    category: 'sans-serif',
    variants: [
      '100',
      '100italic',
      '200',
      '200italic',
      '300',
      '300italic',
      'regular',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
      '900',
      '900italic',
    ],
    subsets: [
      'greek',
      'greek-ext',
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v3',
    lastModified: '2019-04-29',
  },
  {
    popularity: 48,
    newness: 323,
    style: 523,
    trending: 523,
    alphaIndex: 18,
    family: 'Fjalla One',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-05-01',
  },
  {
    popularity: 544,
    newness: 626,
    style: 524,
    trending: 524,
    alphaIndex: 19,
    family: 'Fjord One',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 700,
    newness: 534,
    style: 277,
    trending: 277,
    alphaIndex: 20,
    family: 'Flamenco',
    category: 'display',
    variants: [
      '300',
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-18',
  },
  {
    popularity: 773,
    newness: 535,
    style: 525,
    trending: 525,
    alphaIndex: 21,
    family: 'Flavors',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 511,
    newness: 621,
    style: 278,
    trending: 278,
    alphaIndex: 22,
    family: 'Fondamento',
    category: 'handwriting',
    variants: [
      'regular',
      'italic',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 585,
    newness: 845,
    style: 526,
    trending: 526,
    alphaIndex: 23,
    family: 'Fontdiner Swanky',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-18',
  },
  {
    popularity: 319,
    newness: 720,
    style: 527,
    trending: 527,
    alphaIndex: 24,
    family: 'Forum',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 89,
    newness: 763,
    style: 528,
    trending: 528,
    alphaIndex: 25,
    family: 'Francois One',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v13',
    lastModified: '2019-05-01',
  },
  {
    popularity: 137,
    newness: 113,
    style: 140,
    trending: 140,
    alphaIndex: 26,
    family: 'Frank Ruhl Libre',
    category: 'serif',
    variants: [
      '300',
      'regular',
      '500',
      '700',
      '900',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'hebrew',
    ],
    version: 'v4',
    lastModified: '2019-04-29',
  },
  {
    popularity: 398,
    newness: 291,
    style: 529,
    trending: 529,
    alphaIndex: 27,
    family: 'Freckle Face',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 260,
    newness: 536,
    style: 530,
    trending: 530,
    alphaIndex: 28,
    family: 'Fredericka the Great',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 118,
    newness: 423,
    style: 531,
    trending: 531,
    alphaIndex: 29,
    family: 'Fredoka One',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 831,
    newness: 813,
    style: 532,
    trending: 532,
    alphaIndex: 30,
    family: 'Freehand',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'khmer',
    ],
    version: 'v10',
    lastModified: '2019-04-18',
  },
  {
    popularity: 655,
    newness: 585,
    style: 533,
    trending: 533,
    alphaIndex: 31,
    family: 'Fresca',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 627,
    newness: 537,
    style: 534,
    trending: 534,
    alphaIndex: 32,
    family: 'Frijole',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 890,
    newness: 278,
    style: 535,
    trending: 535,
    alphaIndex: 33,
    family: 'Fruktur',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v11',
    lastModified: '2019-04-18',
  },
  {
    popularity: 259,
    newness: 538,
    style: 536,
    trending: 536,
    alphaIndex: 34,
    family: 'Fugaz One',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 374,
    newness: 888,
    style: 537,
    trending: 537,
    alphaIndex: 0,
    family: 'GFS Didot',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'greek',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 856,
    newness: 889,
    style: 175,
    trending: 175,
    alphaIndex: 1,
    family: 'GFS Neohellenic',
    category: 'sans-serif',
    variants: [
      'regular',
      'italic',
      '700',
      '700italic',
    ],
    subsets: [
      'greek',
    ],
    version: 'v11',
    lastModified: '2019-04-18',
  },
  {
    popularity: 419,
    newness: 270,
    style: 538,
    trending: 538,
    alphaIndex: 2,
    family: 'Gabriela',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'cyrillic',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 707,
    newness: 39,
    style: 226,
    trending: 226,
    alphaIndex: 3,
    family: 'Gaegu',
    category: 'handwriting',
    variants: [
      '300',
      'regular',
      '700',
    ],
    subsets: [
      'korean',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 520,
    newness: 311,
    style: 539,
    trending: 539,
    alphaIndex: 4,
    family: 'Gafata',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 498,
    newness: 114,
    style: 540,
    trending: 540,
    alphaIndex: 5,
    family: 'Galada',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'bengali',
      'latin',
    ],
    version: 'v4',
    lastModified: '2019-04-18',
  },
  {
    popularity: 756,
    newness: 586,
    style: 541,
    trending: 541,
    alphaIndex: 6,
    family: 'Galdeano',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-18',
  },
  {
    popularity: 724,
    newness: 372,
    style: 542,
    trending: 542,
    alphaIndex: 7,
    family: 'Galindo',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 879,
    newness: 50,
    style: 543,
    trending: 543,
    alphaIndex: 8,
    family: 'Gamja Flower',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'korean',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 202,
    newness: 706,
    style: 176,
    trending: 176,
    alphaIndex: 9,
    family: 'Gentium Basic',
    category: 'serif',
    variants: [
      'regular',
      'italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 219,
    newness: 675,
    style: 177,
    trending: 177,
    alphaIndex: 10,
    family: 'Gentium Book Basic',
    category: 'serif',
    variants: [
      'regular',
      'italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 587,
    newness: 879,
    style: 279,
    trending: 279,
    alphaIndex: 11,
    family: 'Geo',
    category: 'sans-serif',
    variants: [
      'regular',
      'italic',
    ],
    subsets: [
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-18',
  },
  {
    popularity: 893,
    newness: 686,
    style: 544,
    trending: 544,
    alphaIndex: 12,
    family: 'Geostar',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-18',
  },
  {
    popularity: 870,
    newness: 687,
    style: 545,
    trending: 545,
    alphaIndex: 13,
    family: 'Geostar Fill',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-18',
  },
  {
    popularity: 596,
    newness: 482,
    style: 546,
    trending: 546,
    alphaIndex: 14,
    family: 'Germania One',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 898,
    newness: 235,
    style: 547,
    trending: 547,
    alphaIndex: 15,
    family: 'Gidugu',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'telugu',
      'latin',
    ],
    version: 'v5',
    lastModified: '2019-04-18',
  },
  {
    popularity: 371,
    newness: 312,
    style: 548,
    trending: 548,
    alphaIndex: 16,
    family: 'Gilda Display',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 439,
    newness: 714,
    style: 549,
    trending: 549,
    alphaIndex: 17,
    family: 'Give You Glory',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 730,
    newness: 449,
    style: 550,
    trending: 550,
    alphaIndex: 18,
    family: 'Glass Antiqua',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 225,
    newness: 472,
    style: 280,
    trending: 280,
    alphaIndex: 19,
    family: 'Glegoo',
    category: 'serif',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'devanagari',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 87,
    newness: 702,
    style: 551,
    trending: 551,
    alphaIndex: 20,
    family: 'Gloria Hallelujah',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-05-01',
  },
  {
    popularity: 816,
    newness: 727,
    style: 552,
    trending: 552,
    alphaIndex: 21,
    family: 'Goblin One',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-18',
  },
  {
    popularity: 210,
    newness: 651,
    style: 553,
    trending: 553,
    alphaIndex: 22,
    family: 'Gochi Hand',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 862,
    newness: 424,
    style: 281,
    trending: 281,
    alphaIndex: 23,
    family: 'Gorditas',
    category: 'display',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 191,
    newness: 44,
    style: 62,
    trending: 62,
    alphaIndex: 24,
    family: 'Gothic A1',
    category: 'sans-serif',
    variants: [
      '100',
      '200',
      '300',
      'regular',
      '500',
      '600',
      '700',
      '800',
      '900',
    ],
    subsets: [
      'korean',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 382,
    newness: 831,
    style: 554,
    trending: 554,
    alphaIndex: 25,
    family: 'Goudy Bookletter 1911',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 363,
    newness: 425,
    style: 555,
    trending: 555,
    alphaIndex: 26,
    family: 'Graduate',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 282,
    newness: 286,
    style: 556,
    trending: 556,
    alphaIndex: 27,
    family: 'Grand Hotel',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 446,
    newness: 728,
    style: 557,
    trending: 557,
    alphaIndex: 28,
    family: 'Gravitas One',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 119,
    newness: 407,
    style: 558,
    trending: 558,
    alphaIndex: 29,
    family: 'Great Vibes',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 734,
    newness: 366,
    style: 559,
    trending: 559,
    alphaIndex: 30,
    family: 'Griffy',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 336,
    newness: 857,
    style: 560,
    trending: 560,
    alphaIndex: 31,
    family: 'Gruppo',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 165,
    newness: 483,
    style: 227,
    trending: 227,
    alphaIndex: 32,
    family: 'Gudea',
    category: 'sans-serif',
    variants: [
      'regular',
      'italic',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 329,
    newness: 51,
    style: 561,
    trending: 561,
    alphaIndex: 33,
    family: 'Gugi',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'korean',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 468,
    newness: 232,
    style: 562,
    trending: 562,
    alphaIndex: 34,
    family: 'Gurajada',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'telugu',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 601,
    newness: 539,
    style: 563,
    trending: 563,
    alphaIndex: 0,
    family: 'Habibi',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 375,
    newness: 244,
    style: 141,
    trending: 141,
    alphaIndex: 1,
    family: 'Halant',
    category: 'serif',
    variants: [
      '300',
      'regular',
      '500',
      '600',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'devanagari',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 192,
    newness: 729,
    style: 564,
    trending: 564,
    alphaIndex: 2,
    family: 'Hammersmith One',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 906,
    newness: 292,
    style: 565,
    trending: 565,
    alphaIndex: 3,
    family: 'Hanalei',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-18',
  },
  {
    popularity: 500,
    newness: 293,
    style: 566,
    trending: 566,
    alphaIndex: 4,
    family: 'Hanalei Fill',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 168,
    newness: 568,
    style: 567,
    trending: 567,
    alphaIndex: 5,
    family: 'Handlee',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 326,
    newness: 890,
    style: 282,
    trending: 282,
    alphaIndex: 6,
    family: 'Hanuman',
    category: 'serif',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'khmer',
    ],
    version: 'v12',
    lastModified: '2019-04-29',
  },
  {
    popularity: 450,
    newness: 426,
    style: 568,
    trending: 568,
    alphaIndex: 7,
    family: 'Happy Monkey',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 557,
    newness: 136,
    style: 569,
    trending: 569,
    alphaIndex: 8,
    family: 'Harmattan',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
      'arabic',
    ],
    version: 'v5',
    lastModified: '2019-04-29',
  },
  {
    popularity: 597,
    newness: 395,
    style: 570,
    trending: 570,
    alphaIndex: 9,
    family: 'Headland One',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 15,
    newness: 137,
    style: 88,
    trending: 88,
    alphaIndex: 10,
    family: 'Heebo',
    category: 'sans-serif',
    variants: [
      '100',
      '300',
      'regular',
      '500',
      '700',
      '800',
      '900',
    ],
    subsets: [
      'latin',
      'hebrew',
    ],
    version: 'v4',
    lastModified: '2019-05-01',
  },
  {
    popularity: 738,
    newness: 450,
    style: 571,
    trending: 571,
    alphaIndex: 11,
    family: 'Henny Penny',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 406,
    newness: 600,
    style: 572,
    trending: 572,
    alphaIndex: 12,
    family: 'Herr Von Muellerhoff',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 912,
    newness: 52,
    style: 573,
    trending: 573,
    alphaIndex: 13,
    family: 'Hi Melody',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'korean',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 37,
    newness: 250,
    style: 142,
    trending: 142,
    alphaIndex: 14,
    family: 'Hind',
    category: 'sans-serif',
    variants: [
      '300',
      'regular',
      '500',
      '600',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'devanagari',
    ],
    version: 'v9',
    lastModified: '2019-05-01',
  },
  {
    popularity: 155,
    newness: 138,
    style: 143,
    trending: 143,
    alphaIndex: 15,
    family: 'Hind Guntur',
    category: 'sans-serif',
    variants: [
      '300',
      'regular',
      '500',
      '600',
      '700',
    ],
    subsets: [
      'latin-ext',
      'telugu',
      'latin',
    ],
    version: 'v4',
    lastModified: '2019-04-29',
  },
  {
    popularity: 97,
    newness: 139,
    style: 144,
    trending: 144,
    alphaIndex: 16,
    family: 'Hind Madurai',
    category: 'sans-serif',
    variants: [
      '300',
      'regular',
      '500',
      '600',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'tamil',
    ],
    version: 'v4',
    lastModified: '2019-04-29',
  },
  {
    popularity: 61,
    newness: 140,
    style: 145,
    trending: 145,
    alphaIndex: 17,
    family: 'Hind Siliguri',
    category: 'sans-serif',
    variants: [
      '300',
      'regular',
      '500',
      '600',
      '700',
    ],
    subsets: [
      'latin-ext',
      'bengali',
      'latin',
    ],
    version: 'v5',
    lastModified: '2019-05-01',
  },
  {
    popularity: 176,
    newness: 141,
    style: 146,
    trending: 146,
    alphaIndex: 18,
    family: 'Hind Vadodara',
    category: 'sans-serif',
    variants: [
      '300',
      'regular',
      '500',
      '600',
      '700',
    ],
    subsets: [
      'latin-ext',
      'gujarati',
      'latin',
    ],
    version: 'v5',
    lastModified: '2019-04-29',
  },
  {
    popularity: 550,
    newness: 764,
    style: 574,
    trending: 574,
    alphaIndex: 19,
    family: 'Holtwood One SC',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-18',
  },
  {
    popularity: 232,
    newness: 846,
    style: 575,
    trending: 575,
    alphaIndex: 20,
    family: 'Homemade Apple',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 418,
    newness: 484,
    style: 576,
    trending: 576,
    alphaIndex: 21,
    family: 'Homenaje',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 306,
    newness: 34,
    style: 22,
    trending: 22,
    alphaIndex: 0,
    family: 'IBM Plex Mono',
    category: 'monospace',
    variants: [
      '100',
      '100italic',
      '200',
      '200italic',
      '300',
      '300italic',
      'regular',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v4',
    lastModified: '2019-04-29',
  },
  {
    popularity: 117,
    newness: 36,
    style: 23,
    trending: 23,
    alphaIndex: 1,
    family: 'IBM Plex Sans',
    category: 'sans-serif',
    variants: [
      '100',
      '100italic',
      '200',
      '200italic',
      '300',
      '300italic',
      'regular',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
    ],
    subsets: [
      'greek',
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 509,
    newness: 35,
    style: 24,
    trending: 24,
    alphaIndex: 2,
    family: 'IBM Plex Sans Condensed',
    category: 'sans-serif',
    variants: [
      '100',
      '100italic',
      '200',
      '200italic',
      '300',
      '300italic',
      'regular',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v5',
    lastModified: '2019-04-29',
  },
  {
    popularity: 170,
    newness: 37,
    style: 25,
    trending: 25,
    alphaIndex: 3,
    family: 'IBM Plex Serif',
    category: 'serif',
    variants: [
      '100',
      '100italic',
      '200',
      '200italic',
      '300',
      '300italic',
      'regular',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 461,
    newness: 898,
    style: 283,
    trending: 283,
    alphaIndex: 4,
    family: 'IM Fell DW Pica',
    category: 'serif',
    variants: [
      'regular',
      'italic',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 753,
    newness: 899,
    style: 577,
    trending: 577,
    alphaIndex: 5,
    family: 'IM Fell DW Pica SC',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-18',
  },
  {
    popularity: 481,
    newness: 900,
    style: 284,
    trending: 284,
    alphaIndex: 6,
    family: 'IM Fell Double Pica',
    category: 'serif',
    variants: [
      'regular',
      'italic',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 818,
    newness: 901,
    style: 578,
    trending: 578,
    alphaIndex: 7,
    family: 'IM Fell Double Pica SC',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-18',
  },
  {
    popularity: 483,
    newness: 902,
    style: 285,
    trending: 285,
    alphaIndex: 8,
    family: 'IM Fell English',
    category: 'serif',
    variants: [
      'regular',
      'italic',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 390,
    newness: 903,
    style: 579,
    trending: 579,
    alphaIndex: 9,
    family: 'IM Fell English SC',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 706,
    newness: 904,
    style: 286,
    trending: 286,
    alphaIndex: 10,
    family: 'IM Fell French Canon',
    category: 'serif',
    variants: [
      'regular',
      'italic',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-18',
  },
  {
    popularity: 781,
    newness: 905,
    style: 580,
    trending: 580,
    alphaIndex: 11,
    family: 'IM Fell French Canon SC',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-18',
  },
  {
    popularity: 718,
    newness: 906,
    style: 287,
    trending: 287,
    alphaIndex: 12,
    family: 'IM Fell Great Primer',
    category: 'serif',
    variants: [
      'regular',
      'italic',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-18',
  },
  {
    popularity: 792,
    newness: 907,
    style: 581,
    trending: 581,
    alphaIndex: 13,
    family: 'IM Fell Great Primer SC',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-18',
  },
  {
    popularity: 804,
    newness: 473,
    style: 582,
    trending: 582,
    alphaIndex: 14,
    family: 'Iceberg',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 558,
    newness: 611,
    style: 583,
    trending: 583,
    alphaIndex: 15,
    family: 'Iceland',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 566,
    newness: 427,
    style: 584,
    trending: 584,
    alphaIndex: 16,
    family: 'Imprima',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 32,
    newness: 914,
    style: 288,
    trending: 288,
    alphaIndex: 17,
    family: 'Inconsolata',
    category: 'monospace',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v17',
    lastModified: '2019-05-01',
  },
  {
    popularity: 467,
    newness: 540,
    style: 585,
    trending: 585,
    alphaIndex: 18,
    family: 'Inder',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 46,
    newness: 803,
    style: 586,
    trending: 586,
    alphaIndex: 19,
    family: 'Indie Flower',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-05-01',
  },
  {
    popularity: 748,
    newness: 498,
    style: 289,
    trending: 289,
    alphaIndex: 20,
    family: 'Inika',
    category: 'serif',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 676,
    newness: 208,
    style: 89,
    trending: 89,
    alphaIndex: 21,
    family: 'Inknut Antiqua',
    category: 'serif',
    variants: [
      '300',
      'regular',
      '500',
      '600',
      '700',
      '800',
      '900',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'devanagari',
    ],
    version: 'v4',
    lastModified: '2019-04-18',
  },
  {
    popularity: 361,
    newness: 771,
    style: 342,
    trending: 342,
    alphaIndex: 4,
    family: 'Inter',
    category: 'display',
    variants: [
      'regular',
      'italic',
      '600',
      '600italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin',
      'latin-ext',
    ],
    version: 'v7',
    lastModified: '2025-09-23',
  },
  {
    popularity: 784,
    newness: 800,
    style: 587,
    trending: 587,
    alphaIndex: 22,
    family: 'Irish Grover',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-18',
  },
  {
    popularity: 157,
    newness: 715,
    style: 178,
    trending: 178,
    alphaIndex: 23,
    family: 'Istok Web',
    category: 'sans-serif',
    variants: [
      'regular',
      'italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v13',
    lastModified: '2019-04-29',
  },
  {
    popularity: 578,
    newness: 428,
    style: 588,
    trending: 588,
    alphaIndex: 24,
    family: 'Italiana',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 270,
    newness: 541,
    style: 589,
    trending: 589,
    alphaIndex: 25,
    family: 'Italianno',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 301,
    newness: 194,
    style: 590,
    trending: 590,
    alphaIndex: 26,
    family: 'Itim',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'thai',
      'vietnamese',
      'latin',
    ],
    version: 'v3',
    lastModified: '2019-04-29',
  },
  {
    popularity: 848,
    newness: 358,
    style: 591,
    trending: 591,
    alphaIndex: 0,
    family: 'Jacques Francois',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 813,
    newness: 359,
    style: 592,
    trending: 592,
    alphaIndex: 1,
    family: 'Jacques Francois Shadow',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 307,
    newness: 213,
    style: 290,
    trending: 290,
    alphaIndex: 2,
    family: 'Jaldi',
    category: 'sans-serif',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'devanagari',
    ],
    version: 'v5',
    lastModified: '2019-04-29',
  },
  {
    popularity: 766,
    newness: 510,
    style: 593,
    trending: 593,
    alphaIndex: 3,
    family: 'Jim Nightshade',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 343,
    newness: 636,
    style: 594,
    trending: 594,
    alphaIndex: 4,
    family: 'Jockey One',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 859,
    newness: 429,
    style: 595,
    trending: 595,
    alphaIndex: 5,
    family: 'Jolly Lodger',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 840,
    newness: 142,
    style: 596,
    trending: 596,
    alphaIndex: 6,
    family: 'Jomhuria',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'arabic',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 45,
    newness: 886,
    style: 48,
    trending: 48,
    alphaIndex: 7,
    family: 'Josefin Sans',
    category: 'sans-serif',
    variants: [
      '100',
      '100italic',
      '300',
      '300italic',
      'regular',
      'italic',
      '600',
      '600italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v13',
    lastModified: '2019-05-01',
  },
  {
    popularity: 160,
    newness: 887,
    style: 49,
    trending: 49,
    alphaIndex: 8,
    family: 'Josefin Slab',
    category: 'serif',
    variants: [
      '100',
      '100italic',
      '300',
      '300italic',
      'regular',
      'italic',
      '600',
      '600italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 744,
    newness: 313,
    style: 597,
    trending: 597,
    alphaIndex: 9,
    family: 'Joti One',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 620,
    newness: 45,
    style: 598,
    trending: 598,
    alphaIndex: 10,
    family: 'Jua',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'korean',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 403,
    newness: 765,
    style: 228,
    trending: 228,
    alphaIndex: 11,
    family: 'Judson',
    category: 'serif',
    variants: [
      'regular',
      'italic',
      '700',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v11',
    lastModified: '2019-04-29',
  },
  {
    popularity: 736,
    newness: 659,
    style: 599,
    trending: 599,
    alphaIndex: 12,
    family: 'Julee',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-18',
  },
  {
    popularity: 224,
    newness: 338,
    style: 600,
    trending: 600,
    alphaIndex: 13,
    family: 'Julius Sans One',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 685,
    newness: 485,
    style: 601,
    trending: 601,
    alphaIndex: 14,
    family: 'Junge',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 258,
    newness: 747,
    style: 147,
    trending: 147,
    alphaIndex: 15,
    family: 'Jura',
    category: 'sans-serif',
    variants: [
      '300',
      'regular',
      '500',
      '600',
      '700',
    ],
    subsets: [
      'greek',
      'greek-ext',
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 134,
    newness: 858,
    style: 602,
    trending: 602,
    alphaIndex: 16,
    family: 'Just Another Hand',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 548,
    newness: 874,
    style: 603,
    trending: 603,
    alphaIndex: 17,
    family: 'Just Me Again Down Here',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 710,
    newness: 17,
    style: 17,
    trending: 17,
    alphaIndex: 0,
    family: 'K2D',
    category: 'sans-serif',
    variants: [
      '100',
      '100italic',
      '200',
      '200italic',
      '300',
      '300italic',
      'regular',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
    ],
    subsets: [
      'latin-ext',
      'thai',
      'vietnamese',
      'latin',
    ],
    version: 'v2',
    lastModified: '2019-04-18',
  },
  {
    popularity: 562,
    newness: 197,
    style: 291,
    trending: 291,
    alphaIndex: 1,
    family: 'Kadwa',
    category: 'serif',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin',
      'devanagari',
    ],
    version: 'v3',
    lastModified: '2019-04-29',
  },
  {
    popularity: 139,
    newness: 242,
    style: 229,
    trending: 229,
    alphaIndex: 2,
    family: 'Kalam',
    category: 'handwriting',
    variants: [
      '300',
      'regular',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'devanagari',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 277,
    newness: 735,
    style: 292,
    trending: 292,
    alphaIndex: 3,
    family: 'Kameron',
    category: 'serif',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 66,
    newness: 187,
    style: 8,
    trending: 8,
    alphaIndex: 4,
    family: 'Kanit',
    category: 'sans-serif',
    variants: [
      '100',
      '100italic',
      '200',
      '200italic',
      '300',
      '300italic',
      'regular',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
      '900',
      '900italic',
    ],
    subsets: [
      'latin-ext',
      'thai',
      'vietnamese',
      'latin',
    ],
    version: 'v4',
    lastModified: '2019-05-01',
  },
  {
    popularity: 810,
    newness: 264,
    style: 230,
    trending: 230,
    alphaIndex: 5,
    family: 'Kantumruy',
    category: 'sans-serif',
    variants: [
      '300',
      'regular',
      '700',
    ],
    subsets: [
      'khmer',
    ],
    version: 'v5',
    lastModified: '2019-04-18',
  },
  {
    popularity: 49,
    newness: 430,
    style: 179,
    trending: 179,
    alphaIndex: 6,
    family: 'Karla',
    category: 'sans-serif',
    variants: [
      'regular',
      'italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-05-01',
  },
  {
    popularity: 250,
    newness: 251,
    style: 148,
    trending: 148,
    alphaIndex: 7,
    family: 'Karma',
    category: 'serif',
    variants: [
      '300',
      'regular',
      '500',
      '600',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'devanagari',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 606,
    newness: 143,
    style: 604,
    trending: 604,
    alphaIndex: 8,
    family: 'Katibeh',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'arabic',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 116,
    newness: 474,
    style: 605,
    trending: 605,
    alphaIndex: 9,
    family: 'Kaushan Script',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 823,
    newness: 115,
    style: 606,
    trending: 606,
    alphaIndex: 10,
    family: 'Kavivanar',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'tamil',
    ],
    version: 'v4',
    lastModified: '2019-04-18',
  },
  {
    popularity: 713,
    newness: 277,
    style: 607,
    trending: 607,
    alphaIndex: 11,
    family: 'Kavoon',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 891,
    newness: 262,
    style: 608,
    trending: 608,
    alphaIndex: 12,
    family: 'Kdam Thmor',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'khmer',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 827,
    newness: 314,
    style: 609,
    trending: 609,
    alphaIndex: 13,
    family: 'Keania One',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 402,
    newness: 703,
    style: 610,
    trending: 610,
    alphaIndex: 14,
    family: 'Kelly Slab',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 825,
    newness: 865,
    style: 611,
    trending: 611,
    alphaIndex: 15,
    family: 'Kenia',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-18',
  },
  {
    popularity: 163,
    newness: 247,
    style: 149,
    trending: 149,
    alphaIndex: 16,
    family: 'Khand',
    category: 'sans-serif',
    variants: [
      '300',
      'regular',
      '500',
      '600',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'devanagari',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 631,
    newness: 814,
    style: 612,
    trending: 612,
    alphaIndex: 17,
    family: 'Khmer',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'khmer',
    ],
    version: 'v11',
    lastModified: '2019-04-18',
  },
  {
    popularity: 241,
    newness: 222,
    style: 150,
    trending: 150,
    alphaIndex: 18,
    family: 'Khula',
    category: 'sans-serif',
    variants: [
      '300',
      'regular',
      '600',
      '700',
      '800',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'devanagari',
    ],
    version: 'v4',
    lastModified: '2019-04-29',
  },
  {
    popularity: 839,
    newness: 46,
    style: 613,
    trending: 613,
    alphaIndex: 19,
    family: 'Kirang Haerang',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'korean',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 675,
    newness: 327,
    style: 614,
    trending: 614,
    alphaIndex: 20,
    family: 'Kite One',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 354,
    newness: 612,
    style: 615,
    trending: 615,
    alphaIndex: 21,
    family: 'Knewave',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 835,
    newness: 18,
    style: 33,
    trending: 33,
    alphaIndex: 22,
    family: 'KoHo',
    category: 'sans-serif',
    variants: [
      '200',
      '200italic',
      '300',
      '300italic',
      'regular',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin-ext',
      'thai',
      'vietnamese',
      'latin',
    ],
    version: 'v2',
    lastModified: '2019-04-18',
  },
  {
    popularity: 858,
    newness: 19,
    style: 34,
    trending: 34,
    alphaIndex: 23,
    family: 'Kodchasan',
    category: 'sans-serif',
    variants: [
      '200',
      '200italic',
      '300',
      '300italic',
      'regular',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin-ext',
      'thai',
      'vietnamese',
      'latin',
    ],
    version: 'v2',
    lastModified: '2019-04-18',
  },
  {
    popularity: 605,
    newness: 176,
    style: 616,
    trending: 616,
    alphaIndex: 24,
    family: 'Kosugi',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'cyrillic',
      'latin',
      'japanese',
    ],
    version: 'v5',
    lastModified: '2019-04-18',
  },
  {
    popularity: 454,
    newness: 177,
    style: 617,
    trending: 617,
    alphaIndex: 25,
    family: 'Kosugi Maru',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'cyrillic',
      'latin',
      'japanese',
    ],
    version: 'v5',
    lastModified: '2019-04-29',
  },
  {
    popularity: 635,
    newness: 475,
    style: 618,
    trending: 618,
    alphaIndex: 26,
    family: 'Kotta One',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 691,
    newness: 815,
    style: 619,
    trending: 619,
    alphaIndex: 27,
    family: 'Koulen',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'khmer',
    ],
    version: 'v12',
    lastModified: '2019-04-18',
  },
  {
    popularity: 628,
    newness: 847,
    style: 620,
    trending: 620,
    alphaIndex: 28,
    family: 'Kranky',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-18',
  },
  {
    popularity: 222,
    newness: 835,
    style: 231,
    trending: 231,
    alphaIndex: 29,
    family: 'Kreon',
    category: 'serif',
    variants: [
      '300',
      'regular',
      '700',
    ],
    subsets: [
      'latin',
    ],
    version: 'v13',
    lastModified: '2019-04-29',
  },
  {
    popularity: 431,
    newness: 859,
    style: 621,
    trending: 621,
    alphaIndex: 30,
    family: 'Kristi',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 592,
    newness: 451,
    style: 622,
    trending: 622,
    alphaIndex: 31,
    family: 'Krona One',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 662,
    newness: 20,
    style: 35,
    trending: 35,
    alphaIndex: 32,
    family: 'Krub',
    category: 'sans-serif',
    variants: [
      '200',
      '200italic',
      '300',
      '300italic',
      'regular',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin-ext',
      'thai',
      'vietnamese',
      'latin',
    ],
    version: 'v2',
    lastModified: '2019-04-18',
  },
  {
    popularity: 703,
    newness: 144,
    style: 623,
    trending: 623,
    alphaIndex: 33,
    family: 'Kumar One',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'gujarati',
      'latin',
    ],
    version: 'v3',
    lastModified: '2019-04-18',
  },
  {
    popularity: 902,
    newness: 145,
    style: 624,
    trending: 624,
    alphaIndex: 34,
    family: 'Kumar One Outline',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'gujarati',
      'latin',
    ],
    version: 'v4',
    lastModified: '2019-04-18',
  },
  {
    popularity: 494,
    newness: 209,
    style: 625,
    trending: 625,
    alphaIndex: 35,
    family: 'Kurale',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'latin',
      'cyrillic-ext',
      'devanagari',
    ],
    version: 'v4',
    lastModified: '2019-04-29',
  },
  {
    popularity: 484,
    newness: 736,
    style: 626,
    trending: 626,
    alphaIndex: 0,
    family: 'La Belle Aurore',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 411,
    newness: 245,
    style: 151,
    trending: 151,
    alphaIndex: 1,
    family: 'Laila',
    category: 'serif',
    variants: [
      '300',
      'regular',
      '500',
      '600',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'devanagari',
    ],
    version: 'v5',
    lastModified: '2019-04-29',
  },
  {
    popularity: 850,
    newness: 226,
    style: 627,
    trending: 627,
    alphaIndex: 2,
    family: 'Lakki Reddy',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'telugu',
      'latin',
    ],
    version: 'v5',
    lastModified: '2019-04-18',
  },
  {
    popularity: 158,
    newness: 146,
    style: 628,
    trending: 628,
    alphaIndex: 3,
    family: 'Lalezar',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
      'arabic',
    ],
    version: 'v5',
    lastModified: '2019-04-29',
  },
  {
    popularity: 768,
    newness: 627,
    style: 629,
    trending: 629,
    alphaIndex: 4,
    family: 'Lancelot',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-18',
  },
  {
    popularity: 341,
    newness: 217,
    style: 630,
    trending: 630,
    alphaIndex: 5,
    family: 'Lateef',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
      'arabic',
    ],
    version: 'v14',
    lastModified: '2019-04-29',
  },
  {
    popularity: 2,
    newness: 866,
    style: 50,
    trending: 50,
    alphaIndex: 6,
    family: 'Lato',
    category: 'sans-serif',
    variants: [
      '100',
      '100italic',
      '300',
      '300italic',
      'regular',
      'italic',
      '700',
      '700italic',
      '900',
      '900italic',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v15',
    lastModified: '2019-05-01',
  },
  {
    popularity: 674,
    newness: 804,
    style: 631,
    trending: 631,
    alphaIndex: 7,
    family: 'League Script',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-18',
  },
  {
    popularity: 286,
    newness: 707,
    style: 632,
    trending: 632,
    alphaIndex: 8,
    family: 'Leckerli One',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 600,
    newness: 452,
    style: 633,
    trending: 633,
    alphaIndex: 9,
    family: 'Ledger',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 364,
    newness: 860,
    style: 232,
    trending: 232,
    alphaIndex: 10,
    family: 'Lekton',
    category: 'sans-serif',
    variants: [
      'regular',
      'italic',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 447,
    newness: 601,
    style: 634,
    trending: 634,
    alphaIndex: 11,
    family: 'Lemon',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 423,
    newness: 147,
    style: 180,
    trending: 180,
    alphaIndex: 12,
    family: 'Lemonada',
    category: 'display',
    variants: [
      '300',
      'regular',
      '600',
      '700',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
      'arabic',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 849,
    newness: 78,
    style: 635,
    trending: 635,
    alphaIndex: 13,
    family: 'Libre Barcode 128',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-18',
  },
  {
    popularity: 908,
    newness: 79,
    style: 636,
    trending: 636,
    alphaIndex: 14,
    family: 'Libre Barcode 128 Text',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-18',
  },
  {
    popularity: 629,
    newness: 80,
    style: 637,
    trending: 637,
    alphaIndex: 15,
    family: 'Libre Barcode 39',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-18',
  },
  {
    popularity: 855,
    newness: 67,
    style: 638,
    trending: 638,
    alphaIndex: 16,
    family: 'Libre Barcode 39 Extended',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 885,
    newness: 68,
    style: 639,
    trending: 639,
    alphaIndex: 17,
    family: 'Libre Barcode 39 Extended Text',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 851,
    newness: 81,
    style: 640,
    trending: 640,
    alphaIndex: 18,
    family: 'Libre Barcode 39 Text',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-18',
  },
  {
    popularity: 40,
    newness: 287,
    style: 233,
    trending: 233,
    alphaIndex: 19,
    family: 'Libre Baskerville',
    category: 'serif',
    variants: [
      'regular',
      'italic',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-05-01',
  },
  {
    popularity: 47,
    newness: 148,
    style: 9,
    trending: 9,
    alphaIndex: 20,
    family: 'Libre Franklin',
    category: 'sans-serif',
    variants: [
      '100',
      '100italic',
      '200',
      '200italic',
      '300',
      '300italic',
      'regular',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
      '900',
      '900italic',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v3',
    lastModified: '2019-05-01',
  },
  {
    popularity: 609,
    newness: 373,
    style: 293,
    trending: 293,
    alphaIndex: 21,
    family: 'Life Savers',
    category: 'display',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-18',
  },
  {
    popularity: 335,
    newness: 499,
    style: 641,
    trending: 641,
    alphaIndex: 22,
    family: 'Lilita One',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 554,
    newness: 266,
    style: 642,
    trending: 642,
    alphaIndex: 23,
    family: 'Lily Script One',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 404,
    newness: 740,
    style: 643,
    trending: 643,
    alphaIndex: 24,
    family: 'Limelight',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 704,
    newness: 637,
    style: 294,
    trending: 294,
    alphaIndex: 25,
    family: 'Linden Hill',
    category: 'serif',
    variants: [
      'regular',
      'italic',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-18',
  },
  {
    popularity: 50,
    newness: 908,
    style: 644,
    trending: 644,
    alphaIndex: 26,
    family: 'Lobster',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v21',
    lastModified: '2019-05-01',
  },
  {
    popularity: 126,
    newness: 731,
    style: 181,
    trending: 181,
    alphaIndex: 27,
    family: 'Lobster Two',
    category: 'display',
    variants: [
      'regular',
      'italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin',
    ],
    version: 'v11',
    lastModified: '2019-04-29',
  },
  {
    popularity: 595,
    newness: 431,
    style: 645,
    trending: 645,
    alphaIndex: 28,
    family: 'Londrina Outline',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 838,
    newness: 432,
    style: 646,
    trending: 646,
    alphaIndex: 29,
    family: 'Londrina Shadow',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-18',
  },
  {
    popularity: 881,
    newness: 433,
    style: 647,
    trending: 647,
    alphaIndex: 30,
    family: 'Londrina Sketch',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 367,
    newness: 434,
    style: 182,
    trending: 182,
    alphaIndex: 31,
    family: 'Londrina Solid',
    category: 'display',
    variants: [
      '100',
      '300',
      'regular',
      '900',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 19,
    newness: 721,
    style: 183,
    trending: 183,
    alphaIndex: 32,
    family: 'Lora',
    category: 'serif',
    variants: [
      'regular',
      'italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v13',
    lastModified: '2019-05-01',
  },
  {
    popularity: 378,
    newness: 722,
    style: 648,
    trending: 648,
    alphaIndex: 33,
    family: 'Love Ya Like A Sister',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 542,
    newness: 723,
    style: 649,
    trending: 649,
    alphaIndex: 34,
    family: 'Loved by the King',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 702,
    newness: 408,
    style: 650,
    trending: 650,
    alphaIndex: 35,
    family: 'Lovers Quarrel',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 115,
    newness: 848,
    style: 651,
    trending: 651,
    alphaIndex: 36,
    family: 'Luckiest Guy',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 249,
    newness: 500,
    style: 295,
    trending: 295,
    alphaIndex: 37,
    family: 'Lusitana',
    category: 'serif',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 292,
    newness: 486,
    style: 652,
    trending: 652,
    alphaIndex: 38,
    family: 'Lustria',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 189,
    newness: 87,
    style: 90,
    trending: 90,
    alphaIndex: 0,
    family: 'M PLUS 1p',
    category: 'sans-serif',
    variants: [
      '100',
      '300',
      'regular',
      '500',
      '700',
      '800',
      '900',
    ],
    subsets: [
      'greek',
      'greek-ext',
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
      'hebrew',
      'japanese',
    ],
    version: 'v17',
    lastModified: '2019-04-29',
  },
  {
    popularity: 316,
    newness: 31,
    style: 91,
    trending: 91,
    alphaIndex: 1,
    family: 'M PLUS Rounded 1c',
    category: 'sans-serif',
    variants: [
      '100',
      '300',
      'regular',
      '500',
      '700',
      '800',
      '900',
    ],
    subsets: [
      'greek',
      'greek-ext',
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
      'hebrew',
      'japanese',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 854,
    newness: 487,
    style: 653,
    trending: 653,
    alphaIndex: 2,
    family: 'Macondo',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 888,
    newness: 488,
    style: 654,
    trending: 654,
    alphaIndex: 3,
    family: 'Macondo Swash Caps',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 429,
    newness: 82,
    style: 92,
    trending: 92,
    alphaIndex: 4,
    family: 'Mada',
    category: 'sans-serif',
    variants: [
      '200',
      '300',
      'regular',
      '500',
      '600',
      '700',
      '900',
    ],
    subsets: [
      'latin',
      'arabic',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 322,
    newness: 501,
    style: 296,
    trending: 296,
    alphaIndex: 5,
    family: 'Magra',
    category: 'sans-serif',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 708,
    newness: 861,
    style: 655,
    trending: 655,
    alphaIndex: 6,
    family: 'Maiden Orange',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-18',
  },
  {
    popularity: 425,
    newness: 149,
    style: 114,
    trending: 114,
    alphaIndex: 7,
    family: 'Maitree',
    category: 'serif',
    variants: [
      '200',
      '300',
      'regular',
      '500',
      '600',
      '700',
    ],
    subsets: [
      'latin-ext',
      'thai',
      'vietnamese',
      'latin',
    ],
    version: 'v3',
    lastModified: '2019-04-29',
  },
  {
    popularity: 794,
    newness: 4,
    style: 656,
    trending: 656,
    alphaIndex: 8,
    family: 'Major Mono Display',
    category: 'monospace',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v2',
    lastModified: '2019-04-18',
  },
  {
    popularity: 535,
    newness: 751,
    style: 657,
    trending: 657,
    alphaIndex: 9,
    family: 'Mako',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 689,
    newness: 21,
    style: 36,
    trending: 36,
    alphaIndex: 10,
    family: 'Mali',
    category: 'handwriting',
    variants: [
      '200',
      '200italic',
      '300',
      '300italic',
      'regular',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin-ext',
      'thai',
      'vietnamese',
      'latin',
    ],
    version: 'v2',
    lastModified: '2019-04-29',
  },
  {
    popularity: 537,
    newness: 236,
    style: 658,
    trending: 658,
    alphaIndex: 11,
    family: 'Mallanna',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'telugu',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 646,
    newness: 237,
    style: 659,
    trending: 659,
    alphaIndex: 12,
    family: 'Mandali',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'telugu',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 684,
    newness: 73,
    style: 78,
    trending: 78,
    alphaIndex: 13,
    family: 'Manuale',
    category: 'serif',
    variants: [
      'regular',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v3',
    lastModified: '2019-04-18',
  },
  {
    popularity: 263,
    newness: 396,
    style: 660,
    trending: 660,
    alphaIndex: 14,
    family: 'Marcellus',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 328,
    newness: 397,
    style: 661,
    trending: 661,
    alphaIndex: 15,
    family: 'Marcellus SC',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 193,
    newness: 642,
    style: 662,
    trending: 662,
    alphaIndex: 16,
    family: 'Marck Script',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 776,
    newness: 296,
    style: 663,
    trending: 663,
    alphaIndex: 17,
    family: 'Margarine',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 330,
    newness: 28,
    style: 184,
    trending: 184,
    alphaIndex: 18,
    family: 'Markazi Text',
    category: 'serif',
    variants: [
      'regular',
      '500',
      '600',
      '700',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
      'arabic',
    ],
    version: 'v5',
    lastModified: '2019-04-29',
  },
  {
    popularity: 749,
    newness: 569,
    style: 664,
    trending: 664,
    alphaIndex: 19,
    family: 'Marko One',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-18',
  },
  {
    popularity: 331,
    newness: 587,
    style: 665,
    trending: 665,
    alphaIndex: 20,
    family: 'Marmelad',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 136,
    newness: 215,
    style: 93,
    trending: 93,
    alphaIndex: 21,
    family: 'Martel',
    category: 'serif',
    variants: [
      '200',
      '300',
      'regular',
      '600',
      '700',
      '800',
      '900',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'devanagari',
    ],
    version: 'v3',
    lastModified: '2019-04-29',
  },
  {
    popularity: 350,
    newness: 216,
    style: 94,
    trending: 94,
    alphaIndex: 22,
    family: 'Martel Sans',
    category: 'sans-serif',
    variants: [
      '200',
      '300',
      'regular',
      '600',
      '700',
      '800',
      '900',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'devanagari',
    ],
    version: 'v5',
    lastModified: '2019-04-29',
  },
  {
    popularity: 340,
    newness: 692,
    style: 185,
    trending: 185,
    alphaIndex: 23,
    family: 'Marvel',
    category: 'sans-serif',
    variants: [
      'regular',
      'italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 448,
    newness: 628,
    style: 297,
    trending: 297,
    alphaIndex: 24,
    family: 'Mate',
    category: 'serif',
    variants: [
      'regular',
      'italic',
    ],
    subsets: [
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 656,
    newness: 629,
    style: 666,
    trending: 666,
    alphaIndex: 25,
    family: 'Mate SC',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 85,
    newness: 741,
    style: 186,
    trending: 186,
    alphaIndex: 26,
    family: 'Maven Pro',
    category: 'sans-serif',
    variants: [
      'regular',
      '500',
      '700',
      '900',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v12',
    lastModified: '2019-03-27',
  },
  {
    popularity: 528,
    newness: 374,
    style: 667,
    trending: 667,
    alphaIndex: 27,
    family: 'McLaren',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 508,
    newness: 836,
    style: 668,
    trending: 668,
    alphaIndex: 28,
    family: 'Meddon',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v11',
    lastModified: '2019-04-29',
  },
  {
    popularity: 808,
    newness: 816,
    style: 669,
    trending: 669,
    alphaIndex: 29,
    family: 'MedievalSharp',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v11',
    lastModified: '2019-04-18',
  },
  {
    popularity: 524,
    newness: 542,
    style: 670,
    trending: 670,
    alphaIndex: 30,
    family: 'Medula One',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-18',
  },
  {
    popularity: 722,
    newness: 168,
    style: 671,
    trending: 671,
    alphaIndex: 31,
    family: 'Meera Inimai',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
      'tamil',
    ],
    version: 'v3',
    lastModified: '2019-04-18',
  },
  {
    popularity: 516,
    newness: 766,
    style: 672,
    trending: 672,
    alphaIndex: 32,
    family: 'Megrim',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 833,
    newness: 367,
    style: 673,
    trending: 673,
    alphaIndex: 33,
    family: 'Meie Script',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 128,
    newness: 315,
    style: 298,
    trending: 298,
    alphaIndex: 34,
    family: 'Merienda',
    category: 'handwriting',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 413,
    newness: 660,
    style: 674,
    trending: 674,
    alphaIndex: 35,
    family: 'Merienda One',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 8,
    newness: 752,
    style: 79,
    trending: 79,
    alphaIndex: 36,
    family: 'Merriweather',
    category: 'serif',
    variants: [
      '300',
      '300italic',
      'regular',
      'italic',
      '700',
      '700italic',
      '900',
      '900italic',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v20',
    lastModified: '2019-05-01',
  },
  {
    popularity: 55,
    newness: 271,
    style: 80,
    trending: 80,
    alphaIndex: 37,
    family: 'Merriweather Sans',
    category: 'sans-serif',
    variants: [
      '300',
      '300italic',
      'regular',
      'italic',
      '700',
      '700italic',
      '800',
      '800italic',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-05-01',
  },
  {
    popularity: 883,
    newness: 817,
    style: 675,
    trending: 675,
    alphaIndex: 38,
    family: 'Metal',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'khmer',
    ],
    version: 'v11',
    lastModified: '2019-04-18',
  },
  {
    popularity: 800,
    newness: 385,
    style: 676,
    trending: 676,
    alphaIndex: 39,
    family: 'Metal Mania',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-18',
  },
  {
    popularity: 615,
    newness: 588,
    style: 677,
    trending: 677,
    alphaIndex: 40,
    family: 'Metamorphous',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-18',
  },
  {
    popularity: 410,
    newness: 753,
    style: 678,
    trending: 678,
    alphaIndex: 41,
    family: 'Metrophobic',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v11',
    lastModified: '2019-04-29',
  },
  {
    popularity: 271,
    newness: 789,
    style: 679,
    trending: 679,
    alphaIndex: 42,
    family: 'Michroma',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 653,
    newness: 288,
    style: 680,
    trending: 680,
    alphaIndex: 43,
    family: 'Milonga',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 857,
    newness: 787,
    style: 681,
    trending: 681,
    alphaIndex: 44,
    family: 'Miltonian',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v12',
    lastModified: '2019-04-18',
  },
  {
    popularity: 787,
    newness: 788,
    style: 682,
    trending: 682,
    alphaIndex: 45,
    family: 'Miltonian Tattoo',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v14',
    lastModified: '2019-04-18',
  },
  {
    popularity: 751,
    newness: 38,
    style: 299,
    trending: 299,
    alphaIndex: 46,
    family: 'Mina',
    category: 'sans-serif',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin-ext',
      'bengali',
      'latin',
    ],
    version: 'v2',
    lastModified: '2019-04-18',
  },
  {
    popularity: 725,
    newness: 543,
    style: 683,
    trending: 683,
    alphaIndex: 47,
    family: 'Miniver',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 391,
    newness: 116,
    style: 300,
    trending: 300,
    alphaIndex: 48,
    family: 'Miriam Libre',
    category: 'sans-serif',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'hebrew',
    ],
    version: 'v5',
    lastModified: '2019-04-29',
  },
  {
    popularity: 522,
    newness: 150,
    style: 187,
    trending: 187,
    alphaIndex: 49,
    family: 'Mirza',
    category: 'display',
    variants: [
      'regular',
      '500',
      '600',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'arabic',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 826,
    newness: 602,
    style: 684,
    trending: 684,
    alphaIndex: 50,
    family: 'Miss Fajardose',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-18',
  },
  {
    popularity: 261,
    newness: 151,
    style: 115,
    trending: 115,
    alphaIndex: 51,
    family: 'Mitr',
    category: 'sans-serif',
    variants: [
      '200',
      '300',
      'regular',
      '500',
      '600',
      '700',
    ],
    subsets: [
      'latin-ext',
      'thai',
      'vietnamese',
      'latin',
    ],
    version: 'v4',
    lastModified: '2019-04-29',
  },
  {
    popularity: 739,
    newness: 218,
    style: 685,
    trending: 685,
    alphaIndex: 52,
    family: 'Modak',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'devanagari',
    ],
    version: 'v4',
    lastModified: '2019-04-18',
  },
  {
    popularity: 811,
    newness: 716,
    style: 686,
    trending: 686,
    alphaIndex: 53,
    family: 'Modern Antiqua',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-18',
  },
  {
    popularity: 545,
    newness: 152,
    style: 687,
    trending: 687,
    alphaIndex: 54,
    family: 'Mogra',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'gujarati',
      'latin',
    ],
    version: 'v5',
    lastModified: '2019-04-18',
  },
  {
    popularity: 246,
    newness: 913,
    style: 688,
    trending: 688,
    alphaIndex: 55,
    family: 'Molengo',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 817,
    newness: 356,
    style: 689,
    trending: 689,
    alphaIndex: 56,
    family: 'Molle',
    category: 'handwriting',
    variants: [
      'italic',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 149,
    newness: 289,
    style: 301,
    trending: 301,
    alphaIndex: 57,
    family: 'Monda',
    category: 'sans-serif',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 765,
    newness: 767,
    style: 690,
    trending: 690,
    alphaIndex: 58,
    family: 'Monofett',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-18',
  },
  {
    popularity: 218,
    newness: 672,
    style: 691,
    trending: 691,
    alphaIndex: 59,
    family: 'Monoton',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 737,
    newness: 603,
    style: 692,
    trending: 692,
    alphaIndex: 60,
    family: 'Monsieur La Doulaise',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 758,
    newness: 489,
    style: 693,
    trending: 693,
    alphaIndex: 61,
    family: 'Montaga',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 472,
    newness: 676,
    style: 694,
    trending: 694,
    alphaIndex: 62,
    family: 'Montez',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 3,
    newness: 570,
    style: 10,
    trending: 10,
    alphaIndex: 63,
    family: 'Montserrat',
    category: 'sans-serif',
    variants: [
      '100',
      '100italic',
      '200',
      '200italic',
      '300',
      '300italic',
      'regular',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
      '900',
      '900italic',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v13',
    lastModified: '2019-05-01',
  },
  {
    popularity: 178,
    newness: 339,
    style: 11,
    trending: 11,
    alphaIndex: 64,
    family: 'Montserrat Alternates',
    category: 'sans-serif',
    variants: [
      '100',
      '100italic',
      '200',
      '200italic',
      '300',
      '300italic',
      'regular',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
      '900',
      '900italic',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 568,
    newness: 340,
    style: 302,
    trending: 302,
    alphaIndex: 65,
    family: 'Montserrat Subrayada',
    category: 'sans-serif',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-18',
  },
  {
    popularity: 795,
    newness: 818,
    style: 695,
    trending: 695,
    alphaIndex: 66,
    family: 'Moul',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'khmer',
    ],
    version: 'v10',
    lastModified: '2019-04-18',
  },
  {
    popularity: 911,
    newness: 819,
    style: 696,
    trending: 696,
    alphaIndex: 67,
    family: 'Moulpali',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'khmer',
    ],
    version: 'v11',
    lastModified: '2019-04-18',
  },
  {
    popularity: 651,
    newness: 871,
    style: 303,
    trending: 303,
    alphaIndex: 68,
    family: 'Mountains of Christmas',
    category: 'display',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin',
    ],
    version: 'v11',
    lastModified: '2019-04-18',
  },
  {
    popularity: 505,
    newness: 306,
    style: 697,
    trending: 697,
    alphaIndex: 69,
    family: 'Mouse Memoirs',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 892,
    newness: 502,
    style: 698,
    trending: 698,
    alphaIndex: 70,
    family: 'Mr Bedfort',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 247,
    newness: 604,
    style: 699,
    trending: 699,
    alphaIndex: 71,
    family: 'Mr Dafoe',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 422,
    newness: 605,
    style: 700,
    trending: 700,
    alphaIndex: 72,
    family: 'Mr De Haviland',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 556,
    newness: 503,
    style: 701,
    trending: 701,
    alphaIndex: 73,
    family: 'Mrs Saint Delafield',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 805,
    newness: 606,
    style: 702,
    trending: 702,
    alphaIndex: 74,
    family: 'Mrs Sheppards',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 56,
    newness: 96,
    style: 95,
    trending: 95,
    alphaIndex: 75,
    family: 'Mukta',
    category: 'sans-serif',
    variants: [
      '200',
      '300',
      'regular',
      '500',
      '600',
      '700',
      '800',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'devanagari',
    ],
    version: 'v6',
    lastModified: '2019-05-01',
  },
  {
    popularity: 660,
    newness: 89,
    style: 96,
    trending: 96,
    alphaIndex: 76,
    family: 'Mukta Mahee',
    category: 'sans-serif',
    variants: [
      '200',
      '300',
      'regular',
      '500',
      '600',
      '700',
      '800',
    ],
    subsets: [
      'latin-ext',
      'gurmukhi',
      'latin',
    ],
    version: 'v4',
    lastModified: '2019-04-18',
  },
  {
    popularity: 399,
    newness: 90,
    style: 97,
    trending: 97,
    alphaIndex: 77,
    family: 'Mukta Malar',
    category: 'sans-serif',
    variants: [
      '200',
      '300',
      'regular',
      '500',
      '600',
      '700',
      '800',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'tamil',
    ],
    version: 'v5',
    lastModified: '2019-04-29',
  },
  {
    popularity: 478,
    newness: 153,
    style: 98,
    trending: 98,
    alphaIndex: 78,
    family: 'Mukta Vaani',
    category: 'sans-serif',
    variants: [
      '200',
      '300',
      'regular',
      '500',
      '600',
      '700',
      '800',
    ],
    subsets: [
      'latin-ext',
      'gujarati',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 21,
    newness: 742,
    style: 26,
    trending: 26,
    alphaIndex: 79,
    family: 'Muli',
    category: 'sans-serif',
    variants: [
      '200',
      '200italic',
      '300',
      '300italic',
      'regular',
      'italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
      '900',
      '900italic',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v13',
    lastModified: '2019-03-27',
  },
  {
    popularity: 693,
    newness: 442,
    style: 703,
    trending: 703,
    alphaIndex: 80,
    family: 'Mystery Quest',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 637,
    newness: 238,
    style: 704,
    trending: 704,
    alphaIndex: 0,
    family: 'NTR',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'telugu',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 345,
    newness: 56,
    style: 705,
    trending: 705,
    alphaIndex: 1,
    family: 'Nanum Brush Script',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'korean',
      'latin',
    ],
    version: 'v16',
    lastModified: '2019-04-29',
  },
  {
    popularity: 31,
    newness: 57,
    style: 234,
    trending: 234,
    alphaIndex: 2,
    family: 'Nanum Gothic',
    category: 'sans-serif',
    variants: [
      'regular',
      '700',
      '800',
    ],
    subsets: [
      'korean',
      'latin',
    ],
    version: 'v16',
    lastModified: '2019-05-01',
  },
  {
    popularity: 254,
    newness: 58,
    style: 304,
    trending: 304,
    alphaIndex: 3,
    family: 'Nanum Gothic Coding',
    category: 'monospace',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'korean',
      'latin',
    ],
    version: 'v13',
    lastModified: '2019-04-29',
  },
  {
    popularity: 144,
    newness: 59,
    style: 235,
    trending: 235,
    alphaIndex: 4,
    family: 'Nanum Myeongjo',
    category: 'serif',
    variants: [
      'regular',
      '700',
      '800',
    ],
    subsets: [
      'korean',
      'latin',
    ],
    version: 'v14',
    lastModified: '2019-04-29',
  },
  {
    popularity: 281,
    newness: 60,
    style: 706,
    trending: 706,
    alphaIndex: 5,
    family: 'Nanum Pen Script',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'korean',
      'latin',
    ],
    version: 'v14',
    lastModified: '2019-04-29',
  },
  {
    popularity: 172,
    newness: 891,
    style: 707,
    trending: 707,
    alphaIndex: 6,
    family: 'Neucha',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'cyrillic',
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 164,
    newness: 832,
    style: 116,
    trending: 116,
    alphaIndex: 7,
    family: 'Neuton',
    category: 'serif',
    variants: [
      '200',
      '300',
      'regular',
      'italic',
      '700',
      '800',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v11',
    lastModified: '2019-04-29',
  },
  {
    popularity: 767,
    newness: 290,
    style: 708,
    trending: 708,
    alphaIndex: 8,
    family: 'New Rocker',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 96,
    newness: 773,
    style: 305,
    trending: 305,
    alphaIndex: 9,
    family: 'News Cycle',
    category: 'sans-serif',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v15',
    lastModified: '2019-04-29',
  },
  {
    popularity: 285,
    newness: 613,
    style: 709,
    trending: 709,
    alphaIndex: 10,
    family: 'Niconne',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 526,
    newness: 22,
    style: 37,
    trending: 37,
    alphaIndex: 11,
    family: 'Niramit',
    category: 'sans-serif',
    variants: [
      '200',
      '200italic',
      '300',
      '300italic',
      'regular',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin-ext',
      'thai',
      'vietnamese',
      'latin',
    ],
    version: 'v3',
    lastModified: '2019-04-29',
  },
  {
    popularity: 372,
    newness: 732,
    style: 710,
    trending: 710,
    alphaIndex: 12,
    family: 'Nixie One',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 274,
    newness: 911,
    style: 117,
    trending: 117,
    alphaIndex: 13,
    family: 'Nobile',
    category: 'sans-serif',
    variants: [
      'regular',
      'italic',
      '500',
      '500italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 715,
    newness: 624,
    style: 306,
    trending: 306,
    alphaIndex: 14,
    family: 'Nokora',
    category: 'serif',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'khmer',
    ],
    version: 'v12',
    lastModified: '2019-04-18',
  },
  {
    popularity: 376,
    newness: 465,
    style: 711,
    trending: 711,
    alphaIndex: 15,
    family: 'Norican',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 673,
    newness: 544,
    style: 712,
    trending: 712,
    alphaIndex: 16,
    family: 'Nosifer',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 914,
    newness: 27,
    style: 713,
    trending: 713,
    alphaIndex: 17,
    family: 'Notable',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v3',
    lastModified: '2019-04-18',
  },
  {
    popularity: 237,
    newness: 754,
    style: 714,
    trending: 714,
    alphaIndex: 18,
    family: 'Nothing You Could Do',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 101,
    newness: 466,
    style: 188,
    trending: 188,
    alphaIndex: 19,
    family: 'Noticia Text',
    category: 'serif',
    variants: [
      'regular',
      'italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 13,
    newness: 272,
    style: 189,
    trending: 189,
    alphaIndex: 20,
    family: 'Noto Sans',
    category: 'sans-serif',
    variants: [
      'regular',
      'italic',
      '700',
      '700italic',
    ],
    subsets: [
      'greek',
      'greek-ext',
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
      'devanagari',
    ],
    version: 'v8',
    lastModified: '2019-05-01',
  },
  {
    popularity: 34,
    newness: 219,
    style: 118,
    trending: 118,
    alphaIndex: 21,
    family: 'Noto Sans JP',
    category: 'sans-serif',
    variants: [
      '100',
      '300',
      'regular',
      '500',
      '700',
      '900',
    ],
    subsets: [
      'latin',
      'japanese',
    ],
    version: 'v23',
    lastModified: '2019-05-01',
  },
  {
    popularity: 36,
    newness: 61,
    style: 119,
    trending: 119,
    alphaIndex: 22,
    family: 'Noto Sans KR',
    category: 'sans-serif',
    variants: [
      '100',
      '300',
      'regular',
      '500',
      '700',
      '900',
    ],
    subsets: [
      'korean',
      'latin',
    ],
    version: 'v11',
    lastModified: '2019-05-01',
  },
  {
    popularity: 200,
    newness: 11,
    style: 120,
    trending: 120,
    alphaIndex: 23,
    family: 'Noto Sans SC',
    category: 'sans-serif',
    variants: [
      '100',
      '300',
      'regular',
      '500',
      '700',
      '900',
    ],
    subsets: [
      'chinese-simplified',
      'cyrillic',
      'vietnamese',
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 74,
    newness: 12,
    style: 121,
    trending: 121,
    alphaIndex: 24,
    family: 'Noto Sans TC',
    category: 'sans-serif',
    variants: [
      '100',
      '300',
      'regular',
      '500',
      '700',
      '900',
    ],
    subsets: [
      'latin',
      'chinese-traditional',
    ],
    version: 'v8',
    lastModified: '2019-05-01',
  },
  {
    popularity: 26,
    newness: 273,
    style: 190,
    trending: 190,
    alphaIndex: 25,
    family: 'Noto Serif',
    category: 'serif',
    variants: [
      'regular',
      'italic',
      '700',
      '700italic',
    ],
    subsets: [
      'greek',
      'greek-ext',
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v7',
    lastModified: '2019-05-01',
  },
  {
    popularity: 230,
    newness: 26,
    style: 99,
    trending: 99,
    alphaIndex: 26,
    family: 'Noto Serif JP',
    category: 'serif',
    variants: [
      '200',
      '300',
      'regular',
      '500',
      '600',
      '700',
      '900',
    ],
    subsets: [
      'latin',
      'japanese',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 426,
    newness: 25,
    style: 100,
    trending: 100,
    alphaIndex: 27,
    family: 'Noto Serif KR',
    category: 'serif',
    variants: [
      '200',
      '300',
      'regular',
      '500',
      '600',
      '700',
      '900',
    ],
    subsets: [
      'korean',
      'latin',
    ],
    version: 'v5',
    lastModified: '2019-04-29',
  },
  {
    popularity: 453,
    newness: 10,
    style: 101,
    trending: 101,
    alphaIndex: 28,
    family: 'Noto Serif SC',
    category: 'serif',
    variants: [
      '200',
      '300',
      'regular',
      '500',
      '600',
      '700',
      '900',
    ],
    subsets: [
      'chinese-simplified',
      'cyrillic',
      'vietnamese',
      'latin',
    ],
    version: 'v5',
    lastModified: '2019-04-29',
  },
  {
    popularity: 613,
    newness: 9,
    style: 102,
    trending: 102,
    alphaIndex: 29,
    family: 'Noto Serif TC',
    category: 'serif',
    variants: [
      '200',
      '300',
      'regular',
      '500',
      '600',
      '700',
      '900',
    ],
    subsets: [
      'cyrillic',
      'vietnamese',
      'latin',
      'chinese-traditional',
    ],
    version: 'v5',
    lastModified: '2019-04-29',
  },
  {
    popularity: 853,
    newness: 792,
    style: 715,
    trending: 715,
    alphaIndex: 30,
    family: 'Nova Cut',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-18',
  },
  {
    popularity: 735,
    newness: 793,
    style: 716,
    trending: 716,
    alphaIndex: 31,
    family: 'Nova Flat',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-18',
  },
  {
    popularity: 579,
    newness: 794,
    style: 717,
    trending: 717,
    alphaIndex: 32,
    family: 'Nova Mono',
    category: 'monospace',
    variants: [
      'regular',
    ],
    subsets: [
      'greek',
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-18',
  },
  {
    popularity: 875,
    newness: 795,
    style: 718,
    trending: 718,
    alphaIndex: 33,
    family: 'Nova Oval',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-18',
  },
  {
    popularity: 619,
    newness: 796,
    style: 719,
    trending: 719,
    alphaIndex: 34,
    family: 'Nova Round',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-18',
  },
  {
    popularity: 752,
    newness: 797,
    style: 720,
    trending: 720,
    alphaIndex: 35,
    family: 'Nova Script',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v11',
    lastModified: '2019-04-18',
  },
  {
    popularity: 697,
    newness: 798,
    style: 721,
    trending: 721,
    alphaIndex: 36,
    family: 'Nova Slim',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-18',
  },
  {
    popularity: 569,
    newness: 784,
    style: 722,
    trending: 722,
    alphaIndex: 37,
    family: 'Nova Square',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v11',
    lastModified: '2019-04-18',
  },
  {
    popularity: 643,
    newness: 677,
    style: 723,
    trending: 723,
    alphaIndex: 38,
    family: 'Numans',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-18',
  },
  {
    popularity: 23,
    newness: 378,
    style: 27,
    trending: 27,
    alphaIndex: 39,
    family: 'Nunito',
    category: 'sans-serif',
    variants: [
      '200',
      '200italic',
      '300',
      '300italic',
      'regular',
      'italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
      '900',
      '900italic',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-05-01',
  },
  {
    popularity: 42,
    newness: 98,
    style: 28,
    trending: 28,
    alphaIndex: 40,
    family: 'Nunito Sans',
    category: 'sans-serif',
    variants: [
      '200',
      '200italic',
      '300',
      '300italic',
      'regular',
      'italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
      '900',
      '900italic',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v4',
    lastModified: '2019-05-01',
  },
  {
    popularity: 815,
    newness: 820,
    style: 724,
    trending: 724,
    alphaIndex: 0,
    family: 'Odor Mean Chey',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'khmer',
    ],
    version: 'v10',
    lastModified: '2019-04-18',
  },
  {
    popularity: 727,
    newness: 328,
    style: 725,
    trending: 725,
    alphaIndex: 1,
    family: 'Offside',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 111,
    newness: 897,
    style: 236,
    trending: 236,
    alphaIndex: 2,
    family: 'Old Standard TT',
    category: 'serif',
    variants: [
      'regular',
      'italic',
      '700',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v11',
    lastModified: '2019-04-29',
  },
  {
    popularity: 802,
    newness: 545,
    style: 726,
    trending: 726,
    alphaIndex: 3,
    family: 'Oldenburg',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 255,
    newness: 409,
    style: 307,
    trending: 307,
    alphaIndex: 4,
    family: 'Oleo Script',
    category: 'display',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 539,
    newness: 300,
    style: 308,
    trending: 308,
    alphaIndex: 5,
    family: 'Oleo Script Swash Caps',
    category: 'display',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 1,
    newness: 837,
    style: 51,
    trending: 51,
    alphaIndex: 6,
    family: 'Open Sans',
    category: 'sans-serif',
    variants: [
      '300',
      '300italic',
      'regular',
      'italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
    ],
    subsets: [
      'greek',
      'greek-ext',
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v16',
    lastModified: '2019-05-01',
  },
  {
    popularity: 17,
    newness: 756,
    style: 237,
    trending: 237,
    alphaIndex: 7,
    family: 'Open Sans Condensed',
    category: 'sans-serif',
    variants: [
      '300',
      '300italic',
      '700',
    ],
    subsets: [
      'greek',
      'greek-ext',
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v13',
    lastModified: '2019-05-01',
  },
  {
    popularity: 344,
    newness: 370,
    style: 727,
    trending: 727,
    alphaIndex: 8,
    family: 'Oranienbaum',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 133,
    newness: 867,
    style: 191,
    trending: 191,
    alphaIndex: 9,
    family: 'Orbitron',
    category: 'sans-serif',
    variants: [
      'regular',
      '500',
      '700',
      '900',
    ],
    subsets: [
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 471,
    newness: 375,
    style: 309,
    trending: 309,
    alphaIndex: 10,
    family: 'Oregano',
    category: 'display',
    variants: [
      'regular',
      'italic',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 540,
    newness: 360,
    style: 728,
    trending: 728,
    alphaIndex: 11,
    family: 'Orienta',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 821,
    newness: 589,
    style: 729,
    trending: 729,
    alphaIndex: 12,
    family: 'Original Surfer',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 6,
    newness: 443,
    style: 122,
    trending: 122,
    alphaIndex: 13,
    family: 'Oswald',
    category: 'sans-serif',
    variants: [
      '200',
      '300',
      'regular',
      '500',
      '600',
      '700',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
    ],
    version: 'v17',
    lastModified: '2019-03-27',
  },
  {
    popularity: 583,
    newness: 774,
    style: 730,
    trending: 730,
    alphaIndex: 14,
    family: 'Over the Rainbow',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-18',
  },
  {
    popularity: 290,
    newness: 546,
    style: 123,
    trending: 123,
    alphaIndex: 15,
    family: 'Overlock',
    category: 'display',
    variants: [
      'regular',
      'italic',
      '700',
      '700italic',
      '900',
      '900italic',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 721,
    newness: 547,
    style: 731,
    trending: 731,
    alphaIndex: 16,
    family: 'Overlock SC',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 86,
    newness: 106,
    style: 18,
    trending: 18,
    alphaIndex: 17,
    family: 'Overpass',
    category: 'sans-serif',
    variants: [
      '100',
      '100italic',
      '200',
      '200italic',
      '300',
      '300italic',
      'regular',
      'italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
      '900',
      '900italic',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v3',
    lastModified: '2019-05-01',
  },
  {
    popularity: 552,
    newness: 107,
    style: 192,
    trending: 192,
    alphaIndex: 18,
    family: 'Overpass Mono',
    category: 'monospace',
    variants: [
      '300',
      'regular',
      '600',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v4',
    lastModified: '2019-04-29',
  },
  {
    popularity: 373,
    newness: 708,
    style: 732,
    trending: 732,
    alphaIndex: 19,
    family: 'Ovo',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 39,
    newness: 410,
    style: 238,
    trending: 238,
    alphaIndex: 20,
    family: 'Oxygen',
    category: 'sans-serif',
    variants: [
      '300',
      'regular',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-05-01',
  },
  {
    popularity: 396,
    newness: 357,
    style: 733,
    trending: 733,
    alphaIndex: 21,
    family: 'Oxygen Mono',
    category: 'monospace',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 209,
    newness: 444,
    style: 734,
    trending: 734,
    alphaIndex: 0,
    family: 'PT Mono',
    category: 'monospace',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 11,
    newness: 892,
    style: 193,
    trending: 193,
    alphaIndex: 1,
    family: 'PT Sans',
    category: 'sans-serif',
    variants: [
      'regular',
      'italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v10',
    lastModified: '2019-05-01',
  },
  {
    popularity: 103,
    newness: 893,
    style: 310,
    trending: 310,
    alphaIndex: 2,
    family: 'PT Sans Caption',
    category: 'sans-serif',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v11',
    lastModified: '2019-04-29',
  },
  {
    popularity: 25,
    newness: 894,
    style: 311,
    trending: 311,
    alphaIndex: 3,
    family: 'PT Sans Narrow',
    category: 'sans-serif',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v10',
    lastModified: '2019-05-01',
  },
  {
    popularity: 20,
    newness: 833,
    style: 194,
    trending: 194,
    alphaIndex: 4,
    family: 'PT Serif',
    category: 'serif',
    variants: [
      'regular',
      'italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v10',
    lastModified: '2019-05-01',
  },
  {
    popularity: 272,
    newness: 834,
    style: 312,
    trending: 312,
    alphaIndex: 5,
    family: 'PT Serif Caption',
    category: 'serif',
    variants: [
      'regular',
      'italic',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 52,
    newness: 805,
    style: 735,
    trending: 735,
    alphaIndex: 6,
    family: 'Pacifico',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
    ],
    version: 'v13',
    lastModified: '2019-05-01',
  },
  {
    popularity: 699,
    newness: 108,
    style: 313,
    trending: 313,
    alphaIndex: 7,
    family: 'Padauk',
    category: 'sans-serif',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'myanmar',
      'latin',
    ],
    version: 'v5',
    lastModified: '2019-04-18',
  },
  {
    popularity: 313,
    newness: 223,
    style: 103,
    trending: 103,
    alphaIndex: 8,
    family: 'Palanquin',
    category: 'sans-serif',
    variants: [
      '100',
      '200',
      '300',
      'regular',
      '500',
      '600',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'devanagari',
    ],
    version: 'v4',
    lastModified: '2019-04-29',
  },
  {
    popularity: 444,
    newness: 224,
    style: 195,
    trending: 195,
    alphaIndex: 9,
    family: 'Palanquin Dark',
    category: 'sans-serif',
    variants: [
      'regular',
      '500',
      '600',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'devanagari',
    ],
    version: 'v5',
    lastModified: '2019-04-29',
  },
  {
    popularity: 304,
    newness: 97,
    style: 736,
    trending: 736,
    alphaIndex: 10,
    family: 'Pangolin',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v4',
    lastModified: '2019-04-29',
  },
  {
    popularity: 665,
    newness: 329,
    style: 737,
    trending: 737,
    alphaIndex: 11,
    family: 'Paprika',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 214,
    newness: 476,
    style: 738,
    trending: 738,
    alphaIndex: 12,
    family: 'Parisienne',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 876,
    newness: 668,
    style: 739,
    trending: 739,
    alphaIndex: 13,
    family: 'Passero One',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-18',
  },
  {
    popularity: 151,
    newness: 571,
    style: 239,
    trending: 239,
    alphaIndex: 14,
    family: 'Passion One',
    category: 'display',
    variants: [
      'regular',
      '700',
      '900',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 121,
    newness: 267,
    style: 740,
    trending: 740,
    alphaIndex: 15,
    family: 'Pathway Gothic One',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 145,
    newness: 724,
    style: 741,
    trending: 741,
    alphaIndex: 16,
    family: 'Patrick Hand',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v12',
    lastModified: '2019-04-29',
  },
  {
    popularity: 489,
    newness: 274,
    style: 742,
    trending: 742,
    alphaIndex: 17,
    family: 'Patrick Hand SC',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 388,
    newness: 169,
    style: 743,
    trending: 743,
    alphaIndex: 18,
    family: 'Pattaya',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'thai',
      'cyrillic',
      'vietnamese',
      'latin',
    ],
    version: 'v4',
    lastModified: '2019-04-29',
  },
  {
    popularity: 108,
    newness: 548,
    style: 744,
    trending: 744,
    alphaIndex: 19,
    family: 'Patua One',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 688,
    newness: 154,
    style: 745,
    trending: 745,
    alphaIndex: 20,
    family: 'Pavanam',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'tamil',
    ],
    version: 'v3',
    lastModified: '2019-04-18',
  },
  {
    popularity: 156,
    newness: 768,
    style: 746,
    trending: 746,
    alphaIndex: 21,
    family: 'Paytone One',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v11',
    lastModified: '2019-04-29',
  },
  {
    popularity: 900,
    newness: 239,
    style: 747,
    trending: 747,
    alphaIndex: 22,
    family: 'Peddana',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'telugu',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 694,
    newness: 386,
    style: 748,
    trending: 748,
    alphaIndex: 23,
    family: 'Peralta',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 90,
    newness: 849,
    style: 749,
    trending: 749,
    alphaIndex: 24,
    family: 'Permanent Marker',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-05-01',
  },
  {
    popularity: 349,
    newness: 361,
    style: 750,
    trending: 750,
    alphaIndex: 25,
    family: 'Petit Formal Script',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 719,
    newness: 630,
    style: 751,
    trending: 751,
    alphaIndex: 26,
    family: 'Petrona',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 183,
    newness: 669,
    style: 196,
    trending: 196,
    alphaIndex: 27,
    family: 'Philosopher',
    category: 'sans-serif',
    variants: [
      'regular',
      'italic',
      '700',
      '700italic',
    ],
    subsets: [
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 845,
    newness: 607,
    style: 752,
    trending: 752,
    alphaIndex: 28,
    family: 'Piedra',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 283,
    newness: 643,
    style: 753,
    trending: 753,
    alphaIndex: 29,
    family: 'Pinyon Script',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 659,
    newness: 316,
    style: 754,
    trending: 754,
    alphaIndex: 30,
    family: 'Pirata One',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 712,
    newness: 572,
    style: 755,
    trending: 755,
    alphaIndex: 31,
    family: 'Plaster',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-18',
  },
  {
    popularity: 83,
    newness: 769,
    style: 314,
    trending: 314,
    alphaIndex: 32,
    family: 'Play',
    category: 'sans-serif',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'greek',
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v10',
    lastModified: '2019-05-01',
  },
  {
    popularity: 142,
    newness: 549,
    style: 756,
    trending: 756,
    alphaIndex: 33,
    family: 'Playball',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 18,
    newness: 622,
    style: 124,
    trending: 124,
    alphaIndex: 34,
    family: 'Playfair Display',
    category: 'serif',
    variants: [
      'regular',
      'italic',
      '700',
      '700italic',
      '900',
      '900italic',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
    ],
    version: 'v14',
    lastModified: '2019-05-01',
  },
  {
    popularity: 162,
    newness: 330,
    style: 125,
    trending: 125,
    alphaIndex: 35,
    family: 'Playfair Display SC',
    category: 'serif',
    variants: [
      'regular',
      'italic',
      '700',
      '700italic',
      '900',
      '900italic',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 529,
    newness: 748,
    style: 152,
    trending: 152,
    alphaIndex: 36,
    family: 'Podkova',
    category: 'serif',
    variants: [
      'regular',
      '500',
      '600',
      '700',
      '800',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v12',
    lastModified: '2019-04-29',
  },
  {
    popularity: 148,
    newness: 445,
    style: 757,
    trending: 757,
    alphaIndex: 37,
    family: 'Poiret One',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 408,
    newness: 655,
    style: 758,
    trending: 758,
    alphaIndex: 38,
    family: 'Poller One',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 438,
    newness: 631,
    style: 315,
    trending: 315,
    alphaIndex: 39,
    family: 'Poly',
    category: 'serif',
    variants: [
      'regular',
      'italic',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 433,
    newness: 709,
    style: 759,
    trending: 759,
    alphaIndex: 40,
    family: 'Pompiere',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 182,
    newness: 435,
    style: 760,
    trending: 760,
    alphaIndex: 41,
    family: 'Pontano Sans',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 789,
    newness: 53,
    style: 761,
    trending: 761,
    alphaIndex: 42,
    family: 'Poor Story',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'korean',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 12,
    newness: 202,
    style: 12,
    trending: 12,
    alphaIndex: 43,
    family: 'Poppins',
    category: 'sans-serif',
    variants: [
      '100',
      '100italic',
      '200',
      '200italic',
      '300',
      '300italic',
      'regular',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
      '900',
      '900italic',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'devanagari',
    ],
    version: 'v6',
    lastModified: '2019-05-01',
  },
  {
    popularity: 586,
    newness: 490,
    style: 762,
    trending: 762,
    alphaIndex: 44,
    family: 'Port Lligat Sans',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 577,
    newness: 491,
    style: 763,
    trending: 763,
    alphaIndex: 45,
    family: 'Port Lligat Slab',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 161,
    newness: 214,
    style: 316,
    trending: 316,
    alphaIndex: 46,
    family: 'Pragati Narrow',
    category: 'sans-serif',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'devanagari',
    ],
    version: 'v4',
    lastModified: '2019-04-29',
  },
  {
    popularity: 186,
    newness: 661,
    style: 764,
    trending: 764,
    alphaIndex: 47,
    family: 'Prata',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 873,
    newness: 821,
    style: 765,
    trending: 765,
    alphaIndex: 48,
    family: 'Preahvihear',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'khmer',
    ],
    version: 'v10',
    lastModified: '2019-04-18',
  },
  {
    popularity: 231,
    newness: 402,
    style: 766,
    trending: 766,
    alphaIndex: 49,
    family: 'Press Start 2P',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'greek',
      'latin-ext',
      'cyrillic',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 198,
    newness: 155,
    style: 126,
    trending: 126,
    alphaIndex: 50,
    family: 'Pridi',
    category: 'serif',
    variants: [
      '200',
      '300',
      'regular',
      '500',
      '600',
      '700',
    ],
    subsets: [
      'latin-ext',
      'thai',
      'vietnamese',
      'latin',
    ],
    version: 'v4',
    lastModified: '2019-04-29',
  },
  {
    popularity: 658,
    newness: 457,
    style: 767,
    trending: 767,
    alphaIndex: 51,
    family: 'Princess Sofia',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 531,
    newness: 670,
    style: 768,
    trending: 768,
    alphaIndex: 52,
    family: 'Prociono',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 105,
    newness: 156,
    style: 13,
    trending: 13,
    alphaIndex: 53,
    family: 'Prompt',
    category: 'sans-serif',
    variants: [
      '100',
      '100italic',
      '200',
      '200italic',
      '300',
      '300italic',
      'regular',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
      '900',
      '900italic',
    ],
    subsets: [
      'latin-ext',
      'thai',
      'vietnamese',
      'latin',
    ],
    version: 'v3',
    lastModified: '2019-04-29',
  },
  {
    popularity: 303,
    newness: 446,
    style: 769,
    trending: 769,
    alphaIndex: 54,
    family: 'Prosto One',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 499,
    newness: 157,
    style: 52,
    trending: 52,
    alphaIndex: 55,
    family: 'Proza Libre',
    category: 'sans-serif',
    variants: [
      'regular',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v3',
    lastModified: '2019-04-29',
  },
  {
    popularity: 414,
    newness: 880,
    style: 197,
    trending: 197,
    alphaIndex: 56,
    family: 'Puritan',
    category: 'sans-serif',
    variants: [
      'regular',
      'italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 788,
    newness: 297,
    style: 770,
    trending: 770,
    alphaIndex: 57,
    family: 'Purple Purse',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 501,
    newness: 390,
    style: 771,
    trending: 771,
    alphaIndex: 0,
    family: 'Quando',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 280,
    newness: 550,
    style: 198,
    trending: 198,
    alphaIndex: 1,
    family: 'Quantico',
    category: 'sans-serif',
    variants: [
      'regular',
      'italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 135,
    newness: 413,
    style: 317,
    trending: 317,
    alphaIndex: 2,
    family: 'Quattrocento',
    category: 'serif',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 122,
    newness: 458,
    style: 199,
    trending: 199,
    alphaIndex: 3,
    family: 'Quattrocento Sans',
    category: 'sans-serif',
    variants: [
      'regular',
      'italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v11',
    lastModified: '2019-04-29',
  },
  {
    popularity: 69,
    newness: 688,
    style: 772,
    trending: 772,
    alphaIndex: 4,
    family: 'Questrial',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-05-01',
  },
  {
    popularity: 33,
    newness: 638,
    style: 200,
    trending: 200,
    alphaIndex: 5,
    family: 'Quicksand',
    category: 'sans-serif',
    variants: [
      '300',
      'regular',
      '500',
      '700',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-05-01',
  },
  {
    popularity: 618,
    newness: 307,
    style: 773,
    trending: 773,
    alphaIndex: 6,
    family: 'Quintessential',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 488,
    newness: 551,
    style: 774,
    trending: 774,
    alphaIndex: 7,
    family: 'Qwigley',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 357,
    newness: 376,
    style: 775,
    trending: 775,
    alphaIndex: 0,
    family: 'Racing Sans One',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 295,
    newness: 573,
    style: 318,
    trending: 318,
    alphaIndex: 1,
    family: 'Radley',
    category: 'serif',
    variants: [
      'regular',
      'italic',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v13',
    lastModified: '2019-04-29',
  },
  {
    popularity: 81,
    newness: 249,
    style: 153,
    trending: 153,
    alphaIndex: 2,
    family: 'Rajdhani',
    category: 'sans-serif',
    variants: [
      '300',
      'regular',
      '500',
      '600',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'devanagari',
    ],
    version: 'v8',
    lastModified: '2019-05-01',
  },
  {
    popularity: 611,
    newness: 158,
    style: 776,
    trending: 776,
    alphaIndex: 3,
    family: 'Rakkas',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'arabic',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 7,
    newness: 362,
    style: 14,
    trending: 14,
    alphaIndex: 4,
    family: 'Raleway',
    category: 'sans-serif',
    variants: [
      '100',
      '100italic',
      '200',
      '200italic',
      '300',
      '300italic',
      'regular',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
      '900',
      '900italic',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v13',
    lastModified: '2019-05-01',
  },
  {
    popularity: 465,
    newness: 363,
    style: 777,
    trending: 777,
    alphaIndex: 5,
    family: 'Raleway Dots',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 549,
    newness: 240,
    style: 778,
    trending: 778,
    alphaIndex: 6,
    family: 'Ramabhadra',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'telugu',
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-18',
  },
  {
    popularity: 671,
    newness: 233,
    style: 779,
    trending: 779,
    alphaIndex: 7,
    family: 'Ramaraja',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'telugu',
      'latin',
    ],
    version: 'v3',
    lastModified: '2019-04-18',
  },
  {
    popularity: 275,
    newness: 317,
    style: 201,
    trending: 201,
    alphaIndex: 8,
    family: 'Rambla',
    category: 'sans-serif',
    variants: [
      'regular',
      'italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 482,
    newness: 632,
    style: 780,
    trending: 780,
    alphaIndex: 9,
    family: 'Rammetto One',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 594,
    newness: 364,
    style: 781,
    trending: 781,
    alphaIndex: 10,
    family: 'Ranchers',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 257,
    newness: 644,
    style: 782,
    trending: 782,
    alphaIndex: 11,
    family: 'Rancho',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 764,
    newness: 225,
    style: 319,
    trending: 319,
    alphaIndex: 12,
    family: 'Ranga',
    category: 'display',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'devanagari',
    ],
    version: 'v4',
    lastModified: '2019-04-18',
  },
  {
    popularity: 217,
    newness: 159,
    style: 154,
    trending: 154,
    alphaIndex: 13,
    family: 'Rasa',
    category: 'serif',
    variants: [
      '300',
      'regular',
      '500',
      '600',
      '700',
    ],
    subsets: [
      'latin-ext',
      'gujarati',
      'latin',
    ],
    version: 'v4',
    lastModified: '2019-04-29',
  },
  {
    popularity: 513,
    newness: 693,
    style: 783,
    trending: 783,
    alphaIndex: 14,
    family: 'Rationale',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 790,
    newness: 227,
    style: 784,
    trending: 784,
    alphaIndex: 15,
    family: 'Ravi Prakash',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'telugu',
      'latin',
    ],
    version: 'v5',
    lastModified: '2019-04-18',
  },
  {
    popularity: 729,
    newness: 733,
    style: 785,
    trending: 785,
    alphaIndex: 16,
    family: 'Redressed',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-18',
  },
  {
    popularity: 308,
    newness: 170,
    style: 786,
    trending: 786,
    alphaIndex: 17,
    family: 'Reem Kufi',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
      'arabic',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 273,
    newness: 912,
    style: 787,
    trending: 787,
    alphaIndex: 18,
    family: 'Reenie Beanie',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 728,
    newness: 436,
    style: 788,
    trending: 788,
    alphaIndex: 19,
    family: 'Revalia',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 761,
    newness: 203,
    style: 789,
    trending: 789,
    alphaIndex: 20,
    family: 'Rhodium Libre',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'devanagari',
    ],
    version: 'v3',
    lastModified: '2019-04-18',
  },
  {
    popularity: 695,
    newness: 614,
    style: 790,
    trending: 790,
    alphaIndex: 21,
    family: 'Ribeye',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 799,
    newness: 615,
    style: 791,
    trending: 791,
    alphaIndex: 22,
    family: 'Ribeye Marrow',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-18',
  },
  {
    popularity: 76,
    newness: 616,
    style: 792,
    trending: 792,
    alphaIndex: 23,
    family: 'Righteous',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-05-01',
  },
  {
    popularity: 872,
    newness: 302,
    style: 793,
    trending: 793,
    alphaIndex: 24,
    family: 'Risque',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 0,
    newness: 279,
    style: 38,
    trending: 38,
    alphaIndex: 25,
    family: 'Roboto',
    category: 'sans-serif',
    variants: [
      '100',
      '100italic',
      '300',
      '300italic',
      'regular',
      'italic',
      '500',
      '500italic',
      '700',
      '700italic',
      '900',
      '900italic',
    ],
    subsets: [
      'greek',
      'greek-ext',
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v19',
    lastModified: '2019-05-01',
  },
  {
    popularity: 4,
    newness: 391,
    style: 127,
    trending: 127,
    alphaIndex: 26,
    family: 'Roboto Condensed',
    category: 'sans-serif',
    variants: [
      '300',
      '300italic',
      'regular',
      'italic',
      '700',
      '700italic',
    ],
    subsets: [
      'greek',
      'greek-ext',
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v17',
    lastModified: '2019-05-01',
  },
  {
    popularity: 9,
    newness: 210,
    style: 53,
    trending: 53,
    alphaIndex: 27,
    family: 'Roboto Mono',
    category: 'monospace',
    variants: [
      '100',
      '100italic',
      '300',
      '300italic',
      'regular',
      'italic',
      '500',
      '500italic',
      '700',
      '700italic',
    ],
    subsets: [
      'greek',
      'greek-ext',
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v6',
    lastModified: '2019-05-01',
  },
  {
    popularity: 10,
    newness: 269,
    style: 202,
    trending: 202,
    alphaIndex: 28,
    family: 'Roboto Slab',
    category: 'serif',
    variants: [
      '100',
      '300',
      'regular',
      '700',
    ],
    subsets: [
      'greek',
      'greek-ext',
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v8',
    lastModified: '2019-05-01',
  },
  {
    popularity: 299,
    newness: 694,
    style: 794,
    trending: 794,
    alphaIndex: 29,
    family: 'Rochester',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 216,
    newness: 850,
    style: 795,
    trending: 795,
    alphaIndex: 30,
    family: 'Rock Salt',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 98,
    newness: 704,
    style: 63,
    trending: 63,
    alphaIndex: 31,
    family: 'Rokkitt',
    category: 'serif',
    variants: [
      '100',
      '200',
      '300',
      'regular',
      '500',
      '600',
      '700',
      '800',
      '900',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v13',
    lastModified: '2019-04-29',
  },
  {
    popularity: 852,
    newness: 377,
    style: 796,
    trending: 796,
    alphaIndex: 32,
    family: 'Romanesco',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 91,
    newness: 477,
    style: 320,
    trending: 320,
    alphaIndex: 33,
    family: 'Ropa Sans',
    category: 'sans-serif',
    variants: [
      'regular',
      'italic',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 377,
    newness: 662,
    style: 203,
    trending: 203,
    alphaIndex: 34,
    family: 'Rosario',
    category: 'sans-serif',
    variants: [
      'regular',
      'italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin',
    ],
    version: 'v13',
    lastModified: '2019-04-29',
  },
  {
    popularity: 686,
    newness: 411,
    style: 321,
    trending: 321,
    alphaIndex: 35,
    family: 'Rosarivo',
    category: 'serif',
    variants: [
      'regular',
      'italic',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 518,
    newness: 504,
    style: 797,
    trending: 797,
    alphaIndex: 36,
    family: 'Rouge Script',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 493,
    newness: 246,
    style: 798,
    trending: 798,
    alphaIndex: 37,
    family: 'Rozha One',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'devanagari',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 29,
    newness: 190,
    style: 54,
    trending: 54,
    alphaIndex: 38,
    family: 'Rubik',
    category: 'sans-serif',
    variants: [
      '300',
      '300italic',
      'regular',
      'italic',
      '500',
      '500italic',
      '700',
      '700italic',
      '900',
      '900italic',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'latin',
      'hebrew',
    ],
    version: 'v8',
    lastModified: '2019-05-01',
  },
  {
    popularity: 546,
    newness: 258,
    style: 799,
    trending: 799,
    alphaIndex: 39,
    family: 'Rubik Mono One',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 201,
    newness: 505,
    style: 240,
    trending: 240,
    alphaIndex: 40,
    family: 'Ruda',
    category: 'sans-serif',
    variants: [
      'regular',
      '700',
      '900',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 327,
    newness: 318,
    style: 322,
    trending: 322,
    alphaIndex: 41,
    family: 'Rufina',
    category: 'serif',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 843,
    newness: 552,
    style: 800,
    trending: 800,
    alphaIndex: 42,
    family: 'Ruge Boogie',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-18',
  },
  {
    popularity: 709,
    newness: 506,
    style: 801,
    trending: 801,
    alphaIndex: 43,
    family: 'Ruluko',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 771,
    newness: 308,
    style: 802,
    trending: 802,
    alphaIndex: 44,
    family: 'Rum Raisin',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 670,
    newness: 749,
    style: 803,
    trending: 803,
    alphaIndex: 45,
    family: 'Ruslan Display',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-18',
  },
  {
    popularity: 130,
    newness: 403,
    style: 804,
    trending: 804,
    alphaIndex: 46,
    family: 'Russo One',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 774,
    newness: 553,
    style: 805,
    trending: 805,
    alphaIndex: 47,
    family: 'Ruthie',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-18',
  },
  {
    popularity: 440,
    newness: 368,
    style: 806,
    trending: 806,
    alphaIndex: 48,
    family: 'Rye',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 150,
    newness: 309,
    style: 807,
    trending: 807,
    alphaIndex: 0,
    family: 'Sacramento',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 796,
    newness: 198,
    style: 323,
    trending: 323,
    alphaIndex: 1,
    family: 'Sahitya',
    category: 'serif',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin',
      'devanagari',
    ],
    version: 'v3',
    lastModified: '2019-04-18',
  },
  {
    popularity: 652,
    newness: 554,
    style: 808,
    trending: 808,
    alphaIndex: 2,
    family: 'Sail',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-18',
  },
  {
    popularity: 180,
    newness: 74,
    style: 64,
    trending: 64,
    alphaIndex: 3,
    family: 'Saira',
    category: 'sans-serif',
    variants: [
      '100',
      '200',
      '300',
      'regular',
      '500',
      '600',
      '700',
      '800',
      '900',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v3',
    lastModified: '2019-04-29',
  },
  {
    popularity: 337,
    newness: 75,
    style: 65,
    trending: 65,
    alphaIndex: 4,
    family: 'Saira Condensed',
    category: 'sans-serif',
    variants: [
      '100',
      '200',
      '300',
      'regular',
      '500',
      '600',
      '700',
      '800',
      '900',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v4',
    lastModified: '2019-04-29',
  },
  {
    popularity: 169,
    newness: 76,
    style: 66,
    trending: 66,
    alphaIndex: 5,
    family: 'Saira Extra Condensed',
    category: 'sans-serif',
    variants: [
      '100',
      '200',
      '300',
      'regular',
      '500',
      '600',
      '700',
      '800',
      '900',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v4',
    lastModified: '2019-04-29',
  },
  {
    popularity: 253,
    newness: 77,
    style: 67,
    trending: 67,
    alphaIndex: 6,
    family: 'Saira Semi Condensed',
    category: 'sans-serif',
    variants: [
      '100',
      '200',
      '300',
      'regular',
      '500',
      '600',
      '700',
      '800',
      '900',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v4',
    lastModified: '2019-04-29',
  },
  {
    popularity: 581,
    newness: 645,
    style: 809,
    trending: 809,
    alphaIndex: 7,
    family: 'Salsa',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-18',
  },
  {
    popularity: 166,
    newness: 319,
    style: 324,
    trending: 324,
    alphaIndex: 8,
    family: 'Sanchez',
    category: 'serif',
    variants: [
      'regular',
      'italic',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 698,
    newness: 646,
    style: 810,
    trending: 810,
    alphaIndex: 9,
    family: 'Sancreek',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-18',
  },
  {
    popularity: 519,
    newness: 102,
    style: 81,
    trending: 81,
    alphaIndex: 10,
    family: 'Sansita',
    category: 'sans-serif',
    variants: [
      'regular',
      'italic',
      '700',
      '700italic',
      '800',
      '800italic',
      '900',
      '900italic',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v3',
    lastModified: '2019-04-18',
  },
  {
    popularity: 383,
    newness: 263,
    style: 19,
    trending: 19,
    alphaIndex: 11,
    family: 'Sarabun',
    category: 'sans-serif',
    variants: [
      '100',
      '100italic',
      '200',
      '200italic',
      '300',
      '300italic',
      'regular',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
    ],
    subsets: [
      'latin-ext',
      'thai',
      'vietnamese',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 242,
    newness: 199,
    style: 325,
    trending: 325,
    alphaIndex: 12,
    family: 'Sarala',
    category: 'sans-serif',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'devanagari',
    ],
    version: 'v3',
    lastModified: '2019-04-29',
  },
  {
    popularity: 681,
    newness: 555,
    style: 811,
    trending: 811,
    alphaIndex: 13,
    family: 'Sarina',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 588,
    newness: 243,
    style: 128,
    trending: 128,
    alphaIndex: 14,
    family: 'Sarpanch',
    category: 'sans-serif',
    variants: [
      'regular',
      '500',
      '600',
      '700',
      '800',
      '900',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'devanagari',
    ],
    version: 'v4',
    lastModified: '2019-04-18',
  },
  {
    popularity: 100,
    newness: 647,
    style: 812,
    trending: 812,
    alphaIndex: 15,
    family: 'Satisfy',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 267,
    newness: 30,
    style: 813,
    trending: 813,
    alphaIndex: 16,
    family: 'Sawarabi Gothic',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'japanese',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 188,
    newness: 29,
    style: 814,
    trending: 814,
    alphaIndex: 17,
    family: 'Sawarabi Mincho',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'japanese',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 268,
    newness: 383,
    style: 204,
    trending: 204,
    alphaIndex: 18,
    family: 'Scada',
    category: 'sans-serif',
    variants: [
      'regular',
      'italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 311,
    newness: 492,
    style: 326,
    trending: 326,
    alphaIndex: 19,
    family: 'Scheherazade',
    category: 'serif',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin',
      'arabic',
    ],
    version: 'v16',
    lastModified: '2019-04-29',
  },
  {
    popularity: 279,
    newness: 851,
    style: 815,
    trending: 815,
    alphaIndex: 20,
    family: 'Schoolbell',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 555,
    newness: 160,
    style: 816,
    trending: 816,
    alphaIndex: 21,
    family: 'Scope One',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v5',
    lastModified: '2019-04-18',
  },
  {
    popularity: 474,
    newness: 447,
    style: 817,
    trending: 817,
    alphaIndex: 22,
    family: 'Seaweed Script',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 430,
    newness: 172,
    style: 818,
    trending: 818,
    alphaIndex: 23,
    family: 'Secular One',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'hebrew',
    ],
    version: 'v3',
    lastModified: '2019-04-29',
  },
  {
    popularity: 608,
    newness: 69,
    style: 819,
    trending: 819,
    alphaIndex: 24,
    family: 'Sedgwick Ave',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v4',
    lastModified: '2019-04-18',
  },
  {
    popularity: 861,
    newness: 70,
    style: 820,
    trending: 820,
    alphaIndex: 25,
    family: 'Sedgwick Ave Display',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v4',
    lastModified: '2019-04-18',
  },
  {
    popularity: 880,
    newness: 453,
    style: 821,
    trending: 821,
    alphaIndex: 26,
    family: 'Sevillana',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 828,
    newness: 336,
    style: 822,
    trending: 822,
    alphaIndex: 27,
    family: 'Seymour One',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 62,
    newness: 737,
    style: 823,
    trending: 823,
    alphaIndex: 28,
    family: 'Shadows Into Light',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-05-01',
  },
  {
    popularity: 199,
    newness: 454,
    style: 824,
    trending: 824,
    alphaIndex: 29,
    family: 'Shadows Into Light Two',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 603,
    newness: 755,
    style: 825,
    trending: 825,
    alphaIndex: 30,
    family: 'Shanti',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-18',
  },
  {
    popularity: 291,
    newness: 467,
    style: 205,
    trending: 205,
    alphaIndex: 31,
    family: 'Share',
    category: 'display',
    variants: [
      'regular',
      'italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 599,
    newness: 320,
    style: 826,
    trending: 826,
    alphaIndex: 32,
    family: 'Share Tech',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-18',
  },
  {
    popularity: 294,
    newness: 321,
    style: 827,
    trending: 827,
    alphaIndex: 33,
    family: 'Share Tech Mono',
    category: 'monospace',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 356,
    newness: 478,
    style: 828,
    trending: 828,
    alphaIndex: 34,
    family: 'Shojumaru',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 463,
    newness: 678,
    style: 829,
    trending: 829,
    alphaIndex: 35,
    family: 'Short Stack',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 353,
    newness: 161,
    style: 830,
    trending: 830,
    alphaIndex: 36,
    family: 'Shrikhand',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'gujarati',
      'latin',
    ],
    version: 'v4',
    lastModified: '2019-04-29',
  },
  {
    popularity: 801,
    newness: 778,
    style: 831,
    trending: 831,
    alphaIndex: 37,
    family: 'Siemreap',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'khmer',
    ],
    version: 'v11',
    lastModified: '2019-04-18',
  },
  {
    popularity: 229,
    newness: 770,
    style: 832,
    trending: 832,
    alphaIndex: 38,
    family: 'Sigmar One',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 82,
    newness: 617,
    style: 206,
    trending: 206,
    alphaIndex: 39,
    family: 'Signika',
    category: 'sans-serif',
    variants: [
      '300',
      'regular',
      '600',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-05-01',
  },
  {
    popularity: 185,
    newness: 618,
    style: 207,
    trending: 207,
    alphaIndex: 40,
    family: 'Signika Negative',
    category: 'sans-serif',
    variants: [
      '300',
      'regular',
      '600',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 668,
    newness: 404,
    style: 208,
    trending: 208,
    alphaIndex: 41,
    family: 'Simonetta',
    category: 'display',
    variants: [
      'regular',
      'italic',
      '900',
      '900italic',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-18',
  },
  {
    popularity: 221,
    newness: 276,
    style: 327,
    trending: 327,
    alphaIndex: 42,
    family: 'Sintony',
    category: 'sans-serif',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 762,
    newness: 493,
    style: 833,
    trending: 833,
    alphaIndex: 43,
    family: 'Sirin Stencil',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 452,
    newness: 828,
    style: 834,
    trending: 834,
    alphaIndex: 44,
    family: 'Six Caps',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 445,
    newness: 369,
    style: 328,
    trending: 328,
    alphaIndex: 45,
    family: 'Skranji',
    category: 'display',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 359,
    newness: 255,
    style: 835,
    trending: 835,
    alphaIndex: 46,
    family: 'Slabo 13px',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 14,
    newness: 256,
    style: 836,
    trending: 836,
    alphaIndex: 47,
    family: 'Slabo 27px',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v5',
    lastModified: '2019-05-01',
  },
  {
    popularity: 650,
    newness: 852,
    style: 837,
    trending: 837,
    alphaIndex: 48,
    family: 'Slackey',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-18',
  },
  {
    popularity: 834,
    newness: 695,
    style: 838,
    trending: 838,
    alphaIndex: 49,
    family: 'Smokum',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-18',
  },
  {
    popularity: 763,
    newness: 779,
    style: 839,
    trending: 839,
    alphaIndex: 50,
    family: 'Smythe',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-18',
  },
  {
    popularity: 409,
    newness: 868,
    style: 329,
    trending: 329,
    alphaIndex: 51,
    family: 'Sniglet',
    category: 'display',
    variants: [
      'regular',
      '800',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 798,
    newness: 710,
    style: 840,
    trending: 840,
    alphaIndex: 52,
    family: 'Snippet',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-18',
  },
  {
    popularity: 806,
    newness: 294,
    style: 841,
    trending: 841,
    alphaIndex: 53,
    family: 'Snowburst One',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 889,
    newness: 346,
    style: 842,
    trending: 842,
    alphaIndex: 54,
    family: 'Sofadi One',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 320,
    newness: 556,
    style: 843,
    trending: 843,
    alphaIndex: 55,
    family: 'Sofia',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 769,
    newness: 54,
    style: 844,
    trending: 844,
    alphaIndex: 56,
    family: 'Song Myung',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'korean',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 732,
    newness: 494,
    style: 845,
    trending: 845,
    alphaIndex: 57,
    family: 'Sonsie One',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 194,
    newness: 663,
    style: 330,
    trending: 330,
    alphaIndex: 58,
    family: 'Sorts Mill Goudy',
    category: 'serif',
    variants: [
      'regular',
      'italic',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 53,
    newness: 352,
    style: 104,
    trending: 104,
    alphaIndex: 59,
    family: 'Source Code Pro',
    category: 'monospace',
    variants: [
      '200',
      '300',
      'regular',
      '500',
      '600',
      '700',
      '900',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-05-01',
  },
  {
    popularity: 5,
    newness: 380,
    style: 39,
    trending: 39,
    alphaIndex: 60,
    family: 'Source Sans Pro',
    category: 'sans-serif',
    variants: [
      '200',
      '200italic',
      '300',
      '300italic',
      'regular',
      'italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '900',
      '900italic',
    ],
    subsets: [
      'greek',
      'greek-ext',
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v12',
    lastModified: '2019-05-01',
  },
  {
    popularity: 59,
    newness: 257,
    style: 241,
    trending: 241,
    alphaIndex: 61,
    family: 'Source Serif Pro',
    category: 'serif',
    variants: [
      'regular',
      '600',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-05-01',
  },
  {
    popularity: 298,
    newness: 162,
    style: 209,
    trending: 209,
    alphaIndex: 62,
    family: 'Space Mono',
    category: 'monospace',
    variants: [
      'regular',
      'italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v4',
    lastModified: '2019-04-29',
  },
  {
    popularity: 179,
    newness: 780,
    style: 846,
    trending: 846,
    alphaIndex: 63,
    family: 'Special Elite',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 266,
    newness: 88,
    style: 29,
    trending: 29,
    alphaIndex: 64,
    family: 'Spectral',
    category: 'serif',
    variants: [
      '200',
      '200italic',
      '300',
      '300italic',
      'regular',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
    ],
    version: 'v5',
    lastModified: '2019-04-29',
  },
  {
    popularity: 621,
    newness: 65,
    style: 30,
    trending: 30,
    alphaIndex: 65,
    family: 'Spectral SC',
    category: 'serif',
    variants: [
      '200',
      '200italic',
      '300',
      '300italic',
      'regular',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
    ],
    version: 'v4',
    lastModified: '2019-04-18',
  },
  {
    popularity: 443,
    newness: 574,
    style: 847,
    trending: 847,
    alphaIndex: 66,
    family: 'Spicy Rice',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 264,
    newness: 656,
    style: 848,
    trending: 848,
    alphaIndex: 67,
    family: 'Spinnaker',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 604,
    newness: 619,
    style: 849,
    trending: 849,
    alphaIndex: 68,
    family: 'Spirax',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 339,
    newness: 562,
    style: 850,
    trending: 850,
    alphaIndex: 69,
    family: 'Squada One',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 779,
    newness: 228,
    style: 851,
    trending: 851,
    alphaIndex: 70,
    family: 'Sree Krushnadevaraya',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'telugu',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 384,
    newness: 195,
    style: 852,
    trending: 852,
    alphaIndex: 71,
    family: 'Sriracha',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'thai',
      'vietnamese',
      'latin',
    ],
    version: 'v3',
    lastModified: '2019-04-29',
  },
  {
    popularity: 829,
    newness: 23,
    style: 331,
    trending: 331,
    alphaIndex: 72,
    family: 'Srisakdi',
    category: 'display',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin-ext',
      'thai',
      'vietnamese',
      'latin',
    ],
    version: 'v2',
    lastModified: '2019-04-18',
  },
  {
    popularity: 293,
    newness: 8,
    style: 853,
    trending: 853,
    alphaIndex: 73,
    family: 'Staatliches',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v2',
    lastModified: '2019-04-29',
  },
  {
    popularity: 690,
    newness: 303,
    style: 854,
    trending: 854,
    alphaIndex: 74,
    family: 'Stalemate',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 899,
    newness: 371,
    style: 855,
    trending: 855,
    alphaIndex: 75,
    family: 'Stalinist One',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'latin',
    ],
    version: 'v20',
    lastModified: '2019-04-18',
  },
  {
    popularity: 495,
    newness: 725,
    style: 332,
    trending: 332,
    alphaIndex: 76,
    family: 'Stardos Stencil',
    category: 'display',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 692,
    newness: 590,
    style: 856,
    trending: 856,
    alphaIndex: 77,
    family: 'Stint Ultra Condensed',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 711,
    newness: 459,
    style: 857,
    trending: 857,
    alphaIndex: 78,
    family: 'Stint Ultra Expanded',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 701,
    newness: 379,
    style: 333,
    trending: 333,
    alphaIndex: 79,
    family: 'Stoke',
    category: 'serif',
    variants: [
      '300',
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-18',
  },
  {
    popularity: 530,
    newness: 331,
    style: 858,
    trending: 858,
    alphaIndex: 80,
    family: 'Strait',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 903,
    newness: 41,
    style: 859,
    trending: 859,
    alphaIndex: 81,
    family: 'Stylish',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'korean',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 434,
    newness: 785,
    style: 860,
    trending: 860,
    alphaIndex: 82,
    family: 'Sue Ellen Francisco',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 415,
    newness: 173,
    style: 861,
    trending: 861,
    alphaIndex: 83,
    family: 'Suez One',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'hebrew',
    ],
    version: 'v3',
    lastModified: '2019-04-29',
  },
  {
    popularity: 591,
    newness: 211,
    style: 334,
    trending: 334,
    alphaIndex: 84,
    family: 'Sumana',
    category: 'serif',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'devanagari',
    ],
    version: 'v3',
    lastModified: '2019-04-18',
  },
  {
    popularity: 389,
    newness: 42,
    style: 242,
    trending: 242,
    alphaIndex: 85,
    family: 'Sunflower',
    category: 'sans-serif',
    variants: [
      '300',
      '500',
      '700',
    ],
    subsets: [
      'korean',
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 832,
    newness: 853,
    style: 862,
    trending: 862,
    alphaIndex: 86,
    family: 'Sunshiney',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-18',
  },
  {
    popularity: 878,
    newness: 633,
    style: 863,
    trending: 863,
    alphaIndex: 87,
    family: 'Supermercado One',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-18',
  },
  {
    popularity: 720,
    newness: 200,
    style: 335,
    trending: 335,
    alphaIndex: 88,
    family: 'Sura',
    category: 'serif',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'devanagari',
    ],
    version: 'v3',
    lastModified: '2019-04-18',
  },
  {
    popularity: 424,
    newness: 229,
    style: 864,
    trending: 864,
    alphaIndex: 89,
    family: 'Suranna',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'telugu',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 894,
    newness: 230,
    style: 865,
    trending: 865,
    alphaIndex: 90,
    family: 'Suravaram',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'telugu',
      'latin',
    ],
    version: 'v5',
    lastModified: '2019-04-18',
  },
  {
    popularity: 841,
    newness: 822,
    style: 866,
    trending: 866,
    alphaIndex: 91,
    family: 'Suwannaphum',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'khmer',
    ],
    version: 'v12',
    lastModified: '2019-04-18',
  },
  {
    popularity: 723,
    newness: 775,
    style: 867,
    trending: 867,
    alphaIndex: 92,
    family: 'Swanky and Moo Moo',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-18',
  },
  {
    popularity: 300,
    newness: 776,
    style: 336,
    trending: 336,
    alphaIndex: 93,
    family: 'Syncopate',
    category: 'sans-serif',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 153,
    newness: 32,
    style: 105,
    trending: 105,
    alphaIndex: 0,
    family: 'Tajawal',
    category: 'sans-serif',
    variants: [
      '200',
      '300',
      'regular',
      '500',
      '700',
      '800',
      '900',
    ],
    subsets: [
      'latin',
      'arabic',
    ],
    version: 'v2',
    lastModified: '2019-04-29',
  },
  {
    popularity: 138,
    newness: 896,
    style: 337,
    trending: 337,
    alphaIndex: 1,
    family: 'Tangerine',
    category: 'handwriting',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 666,
    newness: 823,
    style: 868,
    trending: 868,
    alphaIndex: 2,
    family: 'Taprom',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'khmer',
    ],
    version: 'v10',
    lastModified: '2019-04-18',
  },
  {
    popularity: 395,
    newness: 275,
    style: 869,
    trending: 869,
    alphaIndex: 3,
    family: 'Tauri',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 220,
    newness: 163,
    style: 15,
    trending: 15,
    alphaIndex: 4,
    family: 'Taviraj',
    category: 'serif',
    variants: [
      '100',
      '100italic',
      '200',
      '200italic',
      '300',
      '300italic',
      'regular',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
      '900',
      '900italic',
    ],
    subsets: [
      'latin-ext',
      'thai',
      'vietnamese',
      'latin',
    ],
    version: 'v4',
    lastModified: '2019-04-29',
  },
  {
    popularity: 77,
    newness: 252,
    style: 155,
    trending: 155,
    alphaIndex: 5,
    family: 'Teko',
    category: 'sans-serif',
    variants: [
      '300',
      'regular',
      '500',
      '600',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'devanagari',
    ],
    version: 'v8',
    lastModified: '2019-05-01',
  },
  {
    popularity: 342,
    newness: 495,
    style: 870,
    trending: 870,
    alphaIndex: 6,
    family: 'Telex',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 868,
    newness: 241,
    style: 871,
    trending: 871,
    alphaIndex: 7,
    family: 'Tenali Ramakrishna',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'telugu',
      'latin',
    ],
    version: 'v5',
    lastModified: '2019-04-18',
  },
  {
    popularity: 321,
    newness: 743,
    style: 872,
    trending: 872,
    alphaIndex: 8,
    family: 'Tenor Sans',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 741,
    newness: 322,
    style: 873,
    trending: 873,
    alphaIndex: 9,
    family: 'Text Me One',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 757,
    newness: 24,
    style: 210,
    trending: 210,
    alphaIndex: 10,
    family: 'Thasadith',
    category: 'sans-serif',
    variants: [
      'regular',
      'italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin-ext',
      'thai',
      'vietnamese',
      'latin',
    ],
    version: 'v2',
    lastModified: '2019-04-18',
  },
  {
    popularity: 533,
    newness: 781,
    style: 874,
    trending: 874,
    alphaIndex: 11,
    family: 'The Girl Next Door',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 572,
    newness: 705,
    style: 243,
    trending: 243,
    alphaIndex: 12,
    family: 'Tienne',
    category: 'serif',
    variants: [
      'regular',
      '700',
      '900',
    ],
    subsets: [
      'latin',
    ],
    version: 'v11',
    lastModified: '2019-04-18',
  },
  {
    popularity: 755,
    newness: 204,
    style: 156,
    trending: 156,
    alphaIndex: 13,
    family: 'Tillana',
    category: 'handwriting',
    variants: [
      'regular',
      '500',
      '600',
      '700',
      '800',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'devanagari',
    ],
    version: 'v4',
    lastModified: '2019-04-18',
  },
  {
    popularity: 560,
    newness: 231,
    style: 875,
    trending: 875,
    alphaIndex: 14,
    family: 'Timmana',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'telugu',
      'latin',
    ],
    version: 'v3',
    lastModified: '2019-04-29',
  },
  {
    popularity: 127,
    newness: 884,
    style: 211,
    trending: 211,
    alphaIndex: 15,
    family: 'Tinos',
    category: 'serif',
    variants: [
      'regular',
      'italic',
      '700',
      '700italic',
    ],
    subsets: [
      'greek',
      'greek-ext',
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
      'hebrew',
    ],
    version: 'v12',
    lastModified: '2019-04-29',
  },
  {
    popularity: 312,
    newness: 507,
    style: 876,
    trending: 876,
    alphaIndex: 16,
    family: 'Titan One',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 22,
    newness: 341,
    style: 40,
    trending: 40,
    alphaIndex: 17,
    family: 'Titillium Web',
    category: 'sans-serif',
    variants: [
      '200',
      '200italic',
      '300',
      '300italic',
      'regular',
      'italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '900',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-05-01',
  },
  {
    popularity: 716,
    newness: 557,
    style: 877,
    trending: 877,
    alphaIndex: 18,
    family: 'Trade Winds',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 387,
    newness: 164,
    style: 16,
    trending: 16,
    alphaIndex: 19,
    family: 'Trirong',
    category: 'serif',
    variants: [
      '100',
      '100italic',
      '200',
      '200italic',
      '300',
      '300italic',
      'regular',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
      '900',
      '900italic',
    ],
    subsets: [
      'latin-ext',
      'thai',
      'vietnamese',
      'latin',
    ],
    version: 'v4',
    lastModified: '2019-04-29',
  },
  {
    popularity: 420,
    newness: 405,
    style: 878,
    trending: 878,
    alphaIndex: 20,
    family: 'Trocchi',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 871,
    newness: 496,
    style: 244,
    trending: 244,
    alphaIndex: 21,
    family: 'Trochut',
    category: 'display',
    variants: [
      'regular',
      'italic',
      '700',
    ],
    subsets: [
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 780,
    newness: 558,
    style: 879,
    trending: 879,
    alphaIndex: 22,
    family: 'Trykker',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 437,
    newness: 696,
    style: 880,
    trending: 880,
    alphaIndex: 23,
    family: 'Tulpen One',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 16,
    newness: 869,
    style: 82,
    trending: 82,
    alphaIndex: 0,
    family: 'Ubuntu',
    category: 'sans-serif',
    variants: [
      '300',
      '300italic',
      'regular',
      'italic',
      '500',
      '500italic',
      '700',
      '700italic',
    ],
    subsets: [
      'greek',
      'greek-ext',
      'latin-ext',
      'cyrillic',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v13',
    lastModified: '2019-05-01',
  },
  {
    popularity: 75,
    newness: 652,
    style: 881,
    trending: 881,
    alphaIndex: 1,
    family: 'Ubuntu Condensed',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'greek',
      'greek-ext',
      'latin-ext',
      'cyrillic',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v9',
    lastModified: '2019-05-01',
  },
  {
    popularity: 223,
    newness: 653,
    style: 212,
    trending: 212,
    alphaIndex: 2,
    family: 'Ubuntu Mono',
    category: 'monospace',
    variants: [
      'regular',
      'italic',
      '700',
      '700italic',
    ],
    subsets: [
      'greek',
      'greek-ext',
      'latin-ext',
      'cyrillic',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 173,
    newness: 757,
    style: 882,
    trending: 882,
    alphaIndex: 3,
    family: 'Ultra',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v11',
    lastModified: '2019-04-29',
  },
  {
    popularity: 504,
    newness: 559,
    style: 883,
    trending: 883,
    alphaIndex: 4,
    family: 'Uncial Antiqua',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 785,
    newness: 351,
    style: 884,
    trending: 884,
    alphaIndex: 5,
    family: 'Underdog',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 195,
    newness: 332,
    style: 885,
    trending: 885,
    alphaIndex: 6,
    family: 'Unica One',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-29',
  },
  {
    popularity: 746,
    newness: 875,
    style: 886,
    trending: 886,
    alphaIndex: 7,
    family: 'UnifrakturCook',
    category: 'display',
    variants: [
      '700',
    ],
    subsets: [
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-18',
  },
  {
    popularity: 490,
    newness: 881,
    style: 887,
    trending: 887,
    alphaIndex: 8,
    family: 'UnifrakturMaguntia',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 527,
    newness: 592,
    style: 338,
    trending: 338,
    alphaIndex: 9,
    family: 'Unkempt',
    category: 'display',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 884,
    newness: 608,
    style: 888,
    trending: 888,
    alphaIndex: 10,
    family: 'Unlock',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-18',
  },
  {
    popularity: 240,
    newness: 711,
    style: 213,
    trending: 213,
    alphaIndex: 11,
    family: 'Unna',
    category: 'serif',
    variants: [
      'regular',
      'italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v12',
    lastModified: '2019-04-29',
  },
  {
    popularity: 190,
    newness: 824,
    style: 889,
    trending: 889,
    alphaIndex: 0,
    family: 'VT323',
    category: 'monospace',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 602,
    newness: 295,
    style: 890,
    trending: 890,
    alphaIndex: 1,
    family: 'Vampiro One',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-18',
  },
  {
    popularity: 203,
    newness: 730,
    style: 891,
    trending: 891,
    alphaIndex: 2,
    family: 'Varela',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 54,
    newness: 717,
    style: 892,
    trending: 892,
    alphaIndex: 3,
    family: 'Varela Round',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'vietnamese',
      'latin',
      'hebrew',
    ],
    version: 'v11',
    lastModified: '2019-05-01',
  },
  {
    popularity: 525,
    newness: 648,
    style: 893,
    trending: 893,
    alphaIndex: 4,
    family: 'Vast Shadow',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 449,
    newness: 248,
    style: 214,
    trending: 214,
    alphaIndex: 5,
    family: 'Vesper Libre',
    category: 'serif',
    variants: [
      'regular',
      '500',
      '700',
      '900',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'devanagari',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 561,
    newness: 870,
    style: 894,
    trending: 894,
    alphaIndex: 6,
    family: 'Vibur',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 177,
    newness: 679,
    style: 895,
    trending: 895,
    alphaIndex: 7,
    family: 'Vidaloka',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v11',
    lastModified: '2019-04-29',
  },
  {
    popularity: 171,
    newness: 591,
    style: 896,
    trending: 896,
    alphaIndex: 8,
    family: 'Viga',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 576,
    newness: 455,
    style: 897,
    trending: 897,
    alphaIndex: 9,
    family: 'Voces',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 147,
    newness: 680,
    style: 215,
    trending: 215,
    alphaIndex: 10,
    family: 'Volkhov',
    category: 'serif',
    variants: [
      'regular',
      'italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 95,
    newness: 895,
    style: 83,
    trending: 83,
    alphaIndex: 11,
    family: 'Vollkorn',
    category: 'serif',
    variants: [
      'regular',
      'italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '900',
      '900italic',
    ],
    subsets: [
      'greek',
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 847,
    newness: 66,
    style: 216,
    trending: 216,
    alphaIndex: 12,
    family: 'Vollkorn SC',
    category: 'serif',
    variants: [
      'regular',
      '600',
      '700',
      '900',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v2',
    lastModified: '2019-04-18',
  },
  {
    popularity: 379,
    newness: 681,
    style: 898,
    trending: 898,
    alphaIndex: 13,
    family: 'Voltaire',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 491,
    newness: 786,
    style: 899,
    trending: 899,
    alphaIndex: 0,
    family: 'Waiting for the Sunrise',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 486,
    newness: 777,
    style: 900,
    trending: 900,
    alphaIndex: 1,
    family: 'Wallpoet',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-04-29',
  },
  {
    popularity: 506,
    newness: 854,
    style: 901,
    trending: 901,
    alphaIndex: 2,
    family: 'Walter Turncoat',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 913,
    newness: 365,
    style: 902,
    trending: 902,
    alphaIndex: 3,
    family: 'Warnes',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-18',
  },
  {
    popularity: 740,
    newness: 508,
    style: 903,
    trending: 903,
    alphaIndex: 4,
    family: 'Wellfleet',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
  {
    popularity: 318,
    newness: 284,
    style: 904,
    trending: 904,
    alphaIndex: 5,
    family: 'Wendy One',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 541,
    newness: 750,
    style: 905,
    trending: 905,
    alphaIndex: 6,
    family: 'Wire One',
    category: 'sans-serif',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 28,
    newness: 193,
    style: 68,
    trending: 68,
    alphaIndex: 7,
    family: 'Work Sans',
    category: 'sans-serif',
    variants: [
      '100',
      '200',
      '300',
      'regular',
      '500',
      '600',
      '700',
      '800',
      '900',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v4',
    lastModified: '2019-05-01',
  },
  {
    popularity: 63,
    newness: 909,
    style: 217,
    trending: 217,
    alphaIndex: 0,
    family: 'Yanone Kaffeesatz',
    category: 'sans-serif',
    variants: [
      '200',
      '300',
      'regular',
      '700',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
    ],
    version: 'v10',
    lastModified: '2019-05-01',
  },
  {
    popularity: 167,
    newness: 205,
    style: 129,
    trending: 129,
    alphaIndex: 1,
    family: 'Yantramanav',
    category: 'sans-serif',
    variants: [
      '100',
      '300',
      'regular',
      '500',
      '700',
      '900',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'devanagari',
    ],
    version: 'v4',
    lastModified: '2019-04-29',
  },
  {
    popularity: 687,
    newness: 165,
    style: 906,
    trending: 906,
    alphaIndex: 2,
    family: 'Yatra One',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'latin',
      'devanagari',
    ],
    version: 'v5',
    lastModified: '2019-04-18',
  },
  {
    popularity: 207,
    newness: 712,
    style: 907,
    trending: 907,
    alphaIndex: 3,
    family: 'Yellowtail',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v9',
    lastModified: '2019-04-29',
  },
  {
    popularity: 909,
    newness: 55,
    style: 908,
    trending: 908,
    alphaIndex: 4,
    family: 'Yeon Sung',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'korean',
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-18',
  },
  {
    popularity: 380,
    newness: 718,
    style: 909,
    trending: 909,
    alphaIndex: 5,
    family: 'Yeseva One',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'latin-ext',
      'cyrillic',
      'vietnamese',
      'latin',
      'cyrillic-ext',
    ],
    version: 'v13',
    lastModified: '2019-04-29',
  },
  {
    popularity: 338,
    newness: 560,
    style: 910,
    trending: 910,
    alphaIndex: 6,
    family: 'Yesteryear',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v7',
    lastModified: '2019-04-29',
  },
  {
    popularity: 184,
    newness: 166,
    style: 157,
    trending: 157,
    alphaIndex: 7,
    family: 'Yrsa',
    category: 'serif',
    variants: [
      '300',
      'regular',
      '500',
      '600',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v4',
    lastModified: '2019-04-29',
  },
  {
    popularity: 622,
    newness: 5,
    style: 911,
    trending: 911,
    alphaIndex: 0,
    family: 'ZCOOL KuaiLe',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'chinese-simplified',
      'latin',
    ],
    version: 'v4',
    lastModified: '2019-04-18',
  },
  {
    popularity: 750,
    newness: 6,
    style: 912,
    trending: 912,
    alphaIndex: 1,
    family: 'ZCOOL QingKe HuangYou',
    category: 'display',
    variants: [
      'regular',
    ],
    subsets: [
      'chinese-simplified',
      'latin',
    ],
    version: 'v4',
    lastModified: '2019-04-18',
  },
  {
    popularity: 814,
    newness: 7,
    style: 913,
    trending: 913,
    alphaIndex: 2,
    family: 'ZCOOL XiaoWei',
    category: 'serif',
    variants: [
      'regular',
    ],
    subsets: [
      'chinese-simplified',
      'latin',
    ],
    version: 'v4',
    lastModified: '2019-04-18',
  },
  {
    popularity: 507,
    newness: 738,
    style: 914,
    trending: 914,
    alphaIndex: 3,
    family: 'Zeyada',
    category: 'handwriting',
    variants: [
      'regular',
    ],
    subsets: [
      'latin',
    ],
    version: 'v8',
    lastModified: '2019-04-29',
  },
  {
    popularity: 152,
    newness: 85,
    style: 55,
    trending: 55,
    alphaIndex: 4,
    family: 'Zilla Slab',
    category: 'serif',
    variants: [
      '300',
      '300italic',
      'regular',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v4',
    lastModified: '2019-04-29',
  },
  {
    popularity: 803,
    newness: 83,
    style: 339,
    trending: 339,
    alphaIndex: 5,
    family: 'Zilla Slab Highlight',
    category: 'display',
    variants: [
      'regular',
      '700',
    ],
    subsets: [
      'latin-ext',
      'latin',
    ],
    version: 'v6',
    lastModified: '2019-04-18',
  },
];
